{
  "app": {
    "name": "Aslen Ops",
    "tagline": "Stok, üretim ve Amazon\ntek yerde.",
    "description": "Aslen Kağıtçılık · Napelia iç operasyon uygulaması. Yalnızca davetli ortaklar erişebilir.",
    "version": "Sürüm {{version}} · Gaziantep",
    "support": "Sorun mu var?",
    "supportLink": "Destek kaydı aç",
    "footer": "Aslen Kağıtçılık\nNapelia · {{year}}",
    "notConfigured": {
      "title": "Supabase yapılandırılmadı",
      "body": "{{file}} içine {{urlVar}} ve {{keyVar}} ekleyin (bkz. README → Kurulum).",
      "inline": "Supabase yapılandırılmadı — {{file}} içine {{urlVar}} ve {{keyVar}} ekleyin."
    }
  },
  "common": {
    "save": "Kaydet",
    "saving": "Kaydediliyor…",
    "cancel": "Vazgeç",
    "close": "Kapat",
    "back": "Geri",
    "continue": "Devam et",
    "delete": "Sil",
    "edit": "Düzenle",
    "add": "Ekle",
    "new": "Yeni",
    "search": "Ara",
    "searchPlaceholder": "Cari, fatura, işlem ara…",
    "all": "Tümü",
    "yes": "Evet",
    "no": "Hayır",
    "loading": "Yükleniyor…",
    "retry": "Tekrar dene",
    "export": "Dışa aktar",
    "columns": "Sütunlar",
    "undo": "Geri al",
    "undoIn": "Geri al {{seconds}}sn",
    "lastUpdated": "son güncelleme {{time}}",
    "lastSync": "son senkron {{time}}",
    "estimate": "tahmin",
    "why": "neden?",
    "optional": "isteğe bağlı",
    "none": "—",
    "total": "Toplam",
    "note": "Not",
    "date": "Tarih",
    "amount": "Tutar",
    "currency": "Para birimi",
    "status": "Durum",
    "type": "Tür",
    "name": "Ad",
    "description": "Açıklama",
    "category": "Kategori",
    "attachment": "Belge",
    "photo": "Foto",
    "comingSoon": "Bu modül {{phase}} kapsamında açılacak",
    "comingSoonHint": "Şirket kurulduktan sonra aktif kullanılacak. Şimdilik ön muhasebe ve ortak harcamaları hazır.",
    "phase": "Faz {{phase}}",
    "goAccounting": "Ön muhasebeye git",
    "signOut": "Çıkış yap",
    "online": "çevrimiçi",
    "live": "canlı",
    "readOnly": "Salt okunur — bu rolde değişiklik yapamazsın",
    "copied": "Kopyalandı",
    "copyLink": "Bağlantıyı kopyala",
    "keyboardHint": "esc kapatır · ⌘⏎ kaydeder"
  },
  "nav": {
    "today": "Bugün",
    "stock": "Stok",
    "items": "Ürünler",
    "procurement": "Satın Alma",
    "production": "Üretim",
    "amazon": "Amazon",
    "planning": "Planlama",
    "costing": "Maliyet",
    "sales": "Satış",
    "accounting": "Ön Muhasebe",
    "documents": "Evraklar",
    "reports": "Raporlar",
    "settings": "Ayarlar",
    "stockSub": {
      "onHand": "Eldeki stok",
      "movements": "Hareket defteri",
      "lots": "Lotlar",
      "counts": "Sayımlar",
      "labels": "Etiketler"
    },
    "collapse": "Kenar çubuğunu daralt",
    "expand": "Kenar çubuğunu genişlet",
    "notifications": "Bildirimler",
    "account": "Hesap menüsü",
    "currencyToggle": "Raporlama para birimi",
    "mainMenu": "Ana menü",
    "phaseShort": "F{{phase}}",
    "themeLight": "Açık tema",
    "themeDark": "Koyu tema",
    "palette": {
      "title": "Komut paleti",
      "description": "Ekranlara ve işlemlere hızlı erişim",
      "empty": "Sonuç yok",
      "actions": "İşlemler",
      "results": "Kayıtlar",
      "go": "Git"
    }
  },
  "auth": {
    "tabs": {
      "password": "Şifre ile",
      "magic": "Bağlantı ile",
      "invite": "Davet"
    },
    "methodLabel": "Giriş yöntemi",
    "welcome": "Tekrar hoş geldin",
    "welcomeLede": "E-posta ve şifrenle giriş yap.",
    "email": "E-posta",
    "password": "Şifre",
    "forgot": "Şifremi unuttum",
    "show": "Göster",
    "hide": "Gizle",
    "remember": "Bu cihazda oturumu açık tut",
    "signIn": "Giriş yap",
    "signingIn": "Giriş yapılıyor…",
    "magicTitle": "Şifresiz giriş",
    "magicLede": "E-postana tek kullanımlık bir bağlantı gönderelim. Bağlantı 15 dakika geçerlidir.",
    "magicSend": "Bağlantı gönder",
    "magicSent": "Gönderildi.",
    "magicSentBody": "{{email}} adresine bakabilirsin. Gelmedi mi?",
    "magicResend": "Tekrar gönder",
    "resetSent": "Şifre sıfırlama bağlantısı {{email}} adresine gönderildi.",
    "invalidCredentials": "E-posta veya şifre hatalı.",
    "rateLimited": "Çok fazla deneme yaptın. Birkaç dakika sonra tekrar dene.",
    "inviteFrom": "{{name}} seni davet etti",
    "inviteTitle": "Ortak davetini kabul et",
    "inviteCompany": "Şirket",
    "inviteRole": "Rol",
    "inviteValidity": "Davet geçerliliği",
    "inviteValidUntil": "7 gün · {{date}} tarihinde dolar",
    "inviteRoleNote": "Ortak rolü tüm modüllere yazma erişimi verir; onaylar iki ortaktan biri tarafından verilebilir.",
    "inviteRoleNoteOther": "Bu rol yalnızca yetkili olduğu ekranları görür.",
    "yourName": "Adın soyadın",
    "setPassword": "Şifre belirle",
    "passwordHint": "En az {{min}} karakter · {{strength}}",
    "strength": [
      "çok zayıf",
      "zayıf",
      "orta",
      "iyi",
      "güçlü"
    ],
    "acceptInvite": "Daveti kabul et ve başla",
    "declineInvite": "Reddet",
    "inviteMissing": "Davet bağlantısı bulunamadı. E-postandaki bağlantıyı aç ya da seni davet eden ortağa sor.",
    "inviteExpired": "Bu davetin süresi dolmuş. Ortağından yeni bir davet iste.",
    "inviteUsed": "Bu davet zaten kullanılmış.",
    "inviteNoSession": "Daveti kabul etmek için önce giriş yap. Hesabını ortağın açtıysa sana verdiği geçici şifreyi kullan; daveti kabul ederken kendi şifreni belirleyeceksin.",
    "inviteDeclined": "Daveti reddettin.",
    "noCompany": "Henüz bir şirkete üye değilsin",
    "noCompanyLede": "İlk kurulumu başlatarak şirketi oluşturabilir ya da ortağından davet isteyebilirsin.",
    "startSetup": "Kurulumu başlat",
    "stats": {
      "sku": "Aktif SKU",
      "marketplaces": "Pazar yeri",
      "warehouses": "Depo"
    },
    "roles": {
      "owner": "Sahip — tam erişim",
      "partner": "Ortak — tam erişim",
      "operator": "Operatör",
      "accountant_readonly": "Muhasebeci — salt okuma",
      "guest": "Misafir"
    }
  },
  "roles": {
    "owner": "Sahip",
    "partner": "Ortak",
    "operator": "Operatör",
    "accountant_readonly": "Muhasebeci",
    "guest": "Misafir"
  },
  "languages": {
    "tr": "Türkçe",
    "en": "English"
  },
  "countries": {
    "TR": "Türkiye",
    "CN": "Çin",
    "US": "ABD",
    "GB": "Birleşik Krallık",
    "DE": "Almanya",
    "FR": "Fransa",
    "IT": "İtalya",
    "ES": "İspanya",
    "NL": "Hollanda"
  },
  "onboarding": {
    "title": "Aslen Ops kurulumu",
    "lede": "Beş adımda temel ayarları kuralım. Her adımı sonra Ayarlar’dan değiştirebilirsin.",
    "progress": "Kurulum",
    "laterNote": "“Sonra bağla” seçtiğin adımlar Bugün ekranında hatırlatma olarak görünür.",
    "stepCounter": "Adım {{n}} / {{total}}",
    "skip": "Kurulumu atla",
    "finish": "Kurulumu bitir",
    "steps": {
      "company": {
        "title": "Şirket & para birimleri",
        "note": "Unvan, vergi no, raporlama para birimi",
        "lede": "Unvan ve vergi bilgileri belgelere basılır. Raporlama para birimi tüm özetlerin varsayılanı olur."
      },
      "warehouses": {
        "title": "Depolar",
        "note": "Kendi depon + her pazar yeri için FBA deposu",
        "lede": "Kendi deponu lokasyon seviyesine kadar tanımla. Her Amazon pazar yeri için ayrı bir FBA deposu otomatik açılır — bu depoların stoğu yalnızca senkronla değişir."
      },
      "units": {
        "title": "Birimler & paket ölçüleri",
        "note": "Adet, paket, koli, kg ve dönüşümler",
        "lede": "Peçete iş kolunda her şey adet · paket · koli · kg arasında dönüşür. Bu üç sayı doğru olmazsa maliyet ve MRP de doğru olmaz."
      },
      "taxes": {
        "title": "Vergi oranları",
        "note": "KDV, ihracat ve ithalat istisnaları",
        "lede": "Yurt içi satış ve alışlarda KDV, Amazon ihracatında istisna uygulanır. İthalatta gümrükte ödenen KDV indirilecek KDV olarak izlenir."
      },
      "amazon": {
        "title": "Amazon bağlantısı",
        "note": "NA ve EU bölgesi · sonra bağlanabilir",
        "lede": "Amazon’u şimdi bağlarsan sipariş, FBA stok ve ödeme verisi otomatik akar. Şimdi bağlamak zorunda değilsin."
      }
    },
    "company": {
      "legalName": "Şirket unvanı",
      "legalNamePlaceholder": "Aslen Kağıtçılık San. ve Tic. Ltd. Şti.",
      "brand": "Marka",
      "taxNo": "Vergi no",
      "taxOffice": "Vergi dairesi",
      "yourName": "Adın soyadın",
      "currencies": "Para birimleri",
      "currenciesNote": "Raporlama para birimi tüm özet ekranlarında varsayılan olur; kur işlem anında dondurulur.",
      "autoFx": "Kuru işlem anında otomatik çek",
      "autoFxSource": "frankfurter.app · yedek TCMB günlük",
      "currencyNotes": {
        "TRY": "Muhasebe ve üretim maliyeti",
        "USD": "Bobin alımı ve Amazon US",
        "EUR": "Amazon EU tahsilatı"
      },
      "currencyNames": {
        "TRY": "Türk lirası",
        "USD": "ABD doları",
        "EUR": "Euro"
      }
    },
    "warehouses": {
      "own": "Kendi depolarım",
      "add": "Depo ekle",
      "defaultName": "Ana depo",
      "code": "Kod",
      "name": "Ad",
      "namePlaceholder": "Fabrika deposu — Şehitkamil",
      "locations": "Lokasyon sayısı",
      "locationsCount": "{{count}} lokasyon",
      "noLocations": "lokasyon yok",
      "locationsSuffix": "lok.",
      "active": "aktif",
      "fba": "FBA depoları",
      "fbaNote": "her pazar yeri için otomatik oluşturulur — stok Amazon senkronundan gelir",
      "fbaName": "{{name}} deposu",
      "sync": "senkron",
      "marketplaces": "Hangi pazar yerlerinde satıyorsun?",
      "needOne": "En az bir depo tanımla",
      "remove": "Depoyu kaldır"
    },
    "units": {
      "chain": "Paket hiyerarşisi",
      "chainNote": "Tüm ekranlardaki adet ↔ paket ↔ koli dönüşümü bu üç sayıdan türer.",
      "packQty": "Paket içi",
      "casePacks": "Koli içi",
      "napkinWeight": "Peçete ağırlığı",
      "pieces": "adet",
      "packs": "paket",
      "gramsPerPiece": "g/adet",
      "piecesValue": "{{value}} adet",
      "packsValue": "{{value}} paket",
      "measures": "Ölçü birimleri",
      "decimals": {
        "0": "ondalık yok",
        "1": "1 ondalık",
        "2": "2 ondalık",
        "3": "3 ondalık"
      },
      "caseLine": "1 koli = {{packs}} paket = {{pieces}} adet ≈ {{kg}} kg",
      "bobbinLine": "1 bobin = {{kg}} kg = {{cases}} koli = {{pieces}} adet",
      "palletLine": "1 palet = {{bobbins}} bobin = {{kg}} kg = {{cases}} koli"
    },
    "taxes": {
      "vat": "KDV oranları",
      "addRate": "Oran ekle",
      "default": "varsayılan",
      "scope": {
        "sale": "satış",
        "purchase": "alış",
        "both": "satış + alış"
      },
      "exportImport": "İhracat ve ithalat",
      "notes": {
        "amazonExport": "Amazon yurt dışı satış",
        "amazonExportNote": "İhracat istisnası · KDV hesaplanmaz",
        "importVat": "İthalat KDV’si (gümrük)",
        "importVatNote": "İndirilecek KDV olarak izlenir",
        "customsDuty": "İthalat gümrük vergisi",
        "customsDutyNote": "GTİP 4803.00.90 · oran teyit bekliyor"
      },
      "confirm": "Oranlar muhasebeci onayı bekliyor"
    },
    "amazon": {
      "na": "NA bölgesi",
      "eu": "EU bölgesi",
      "notConnected": "Bağlı değil",
      "connected": "Bağlı",
      "later": "Sonra bağla",
      "connect": "Bağlan",
      "laterChosen": "Sonra bağlanacak",
      "connectNote": "Seller Central’da uygulama yetkisi Amazon modülünde verilir (Faz 4). Şimdilik CSV yükleme modu kullanılır.",
      "csvInfo": "Amazon’u sonra bağlamayı seçersen uygulama CSV yükleme moduna geçer: sipariş, FBA stok ve ödeme raporlarını elle yükleyip aynı ekranları kullanabilirsin. Bağlantı kurulduğunda geçmiş CSV verisi korunur."
    },
    "saved": "Kurulum adımı kaydedildi",
    "done": "Kurulum tamamlandı"
  },
  "today": {
    "title": "Bugün",
    "greeting": "{{date}} · günaydın {{name}}",
    "greetingAfternoon": "{{date}} · iyi günler {{name}}",
    "greetingEvening": "{{date}} · iyi akşamlar {{name}}",
    "syncNow": "Şimdi senkronize et",
    "cashPosition": "Nakit pozisyonu",
    "partnerBalances": "Ortak hesapları",
    "partnerOwed": "şirketin ortaklara borcu",
    "monthExpenses": "Bu ay giderler",
    "openReceivables": "Açık alacak",
    "openPayables": "Açık borç",
    "stockValue": "Stok değeri",
    "openPurchases": "Açık satın alma",
    "weekProduction": "Bu hafta üretim",
    "laterTiles": "Stok, üretim ve Amazon kutucukları ilgili modüllerle (Faz 2–6) bu satıra eklenir.",
    "quickActions": "Hızlı işlemler",
    "alerts": "Uyarılar",
    "overdue": {
      "receipt": "Tahsilat vadesi {{date}} · kalan {{amount}}",
      "payment": "Ödeme vadesi {{date}} · kalan {{amount}}",
      "days": "{{count}} gün"
    },
    "feed": "Akış",
    "noAlerts": "Uyarı yok — her şey yolunda.",
    "noFeed": "Henüz hareket yok. İlk masrafı eklediğinde burada görünür.",
    "activity": {
      "tx": {
        "expense": "masraf ekledi — {{amount}}",
        "receipt": "tahsilat girdi — {{amount}}",
        "payment": "ödeme girdi — {{amount}}",
        "transfer": "virman yaptı — {{amount}}",
        "income": "gelir girdi — {{amount}}",
        "fx_diff": "kur farkı oluştu — {{amount}}",
        "fee": "masraf girdi — {{amount}}",
        "other": "işlem girdi — {{amount}}"
      },
      "withNote": "{{text}} · {{note}}",
      "txDeleted": "bir işlemi sildi",
      "fxPosted": "kur farkı işlendi — {{amount}}",
      "invoiceDraft": "fatura taslağı oluşturdu",
      "invoice": {
        "open": "faturayı kaydetti",
        "paid": "faturayı kapattı",
        "partially_paid": "faturaya kısmi ödeme eşledi",
        "cancelled": "faturayı iptal etti",
        "other": "faturayı güncelledi"
      },
      "invoiceLine": "{{no}} {{action}} — {{amount}}",
      "invoiceLineNoNumber": "{{action}} — {{amount}}",
      "contactAdded": "cari ekledi — {{name}}",
      "contactUpdated": "cariyi güncelledi — {{name}}",
      "accountOpened": "hesap açtı — {{name}}",
      "accountUpdated": "hesabı güncelledi — {{name}}",
      "memberJoined": "şirkete katıldı",
      "memberUpdated": "üyeliği güncellendi"
    },
    "setupReminder": "Kurulumda “sonra” dediğin adımlar",
    "actions": {
      "expense": "Masraf ekle",
      "receipt": "Tahsilat gir",
      "payment": "Ödeme gir",
      "invoice": "Fatura ekle",
      "transfer": "Virman",
      "contact": "Yeni cari",
      "movement": "Stok hareketi",
      "receiving": "Mal kabul",
      "productionOrder": "Üretim emri",
      "fbaShipment": "FBA sevkiyat",
      "count": "Sayım başlat"
    },
    "approvalsWaiting": "{{count}} onay bekliyor",
    "moduleLater": "Faz {{phase}} ile gelir"
  },
  "accounting": {
    "title": "Ön Muhasebe",
    "nav": {
      "contacts": "Cariler",
      "invoices": "Faturalar",
      "cash": "Kasa / banka",
      "partners": "Ortaklar",
      "period": "Dönem özeti",
      "reconciliation": "Mutabakat"
    },
    "contactTypes": {
      "customer": "müşteri",
      "supplier": "tedarikçi",
      "both": "müşteri + tedarikçi",
      "marketplace": "pazar yeri",
      "partner": "ortak",
      "other": "diğer"
    },
    "contacts": {
      "title": "Cariler",
      "summary": "{{count}} cari · net alacak {{receivable}} · net borç {{payable}}",
      "new": "Yeni cari",
      "filters": {
        "all": "Tümü",
        "customer": "Müşteri",
        "supplier": "Tedarikçi",
        "partner": "Ortak",
        "overdue": "Vadesi geçen"
      },
      "columns": {
        "contact": "Cari",
        "type": "Tip",
        "balance": "Bakiye",
        "b0_30": "0–30",
        "b31_60": "31–60",
        "b61_90": "61–90",
        "b90_plus": "90+"
      },
      "empty": "Henüz cari yok. Müşteri veya tedarikçi ekleyerek başla.",
      "csvName": "cariler",
      "statement": "Ekstre",
      "statementFrom": "Başlangıç",
      "statementTo": "Bitiş",
      "statementOpening": "Devir",
      "statementClosing": "Kapanış",
      "statementMovements": "Hareketler",
      "statementColumns": {
        "date": "Tarih",
        "doc": "Belge",
        "debit": "Borç",
        "credit": "Alacak",
        "balance": "Bakiye"
      },
      "statementEmpty": "Bu aralıkta hareket yok. Tarih aralığını genişletebilirsin.",
      "statementCsv": "ekstre-{{name}}",
      "searchPlaceholder": "Cari, vergi no, e-posta ara…",
      "balanceByCurrency": "Para birimi bazında bakiye",
      "receivable": "{{cur}} alacak",
      "payable": "{{cur}} borç",
      "openInvoices": "{{count}} açık fatura",
      "noMovement": "hareket yok",
      "aging": "Yaşlandırma",
      "buckets": {
        "b0_30": "0–30 gün",
        "b31_60": "31–60 gün",
        "b61_90": "61–90 gün",
        "b90_plus": "90+ gün"
      },
      "openItems": "Açık kalemler",
      "openColumns": {
        "doc": "Belge",
        "date": "Tarih",
        "due": "Vade",
        "remaining": "Kalan"
      },
      "dueIn": "{{date}} · {{days}} gün",
      "dueToday": "{{date}} · bugün",
      "overdueBy": "{{date}} · {{days}} gün geçti",
      "details": "Künye",
      "fields": {
        "type": "Tip",
        "name": "Unvan / ad",
        "taxNo": "Vergi no / TCKN",
        "taxOffice": "Vergi dairesi",
        "country": "Ülke",
        "city": "Şehir",
        "currency": "Varsayılan para birimi",
        "paymentTerms": "Ödeme vadesi (gün)",
        "riskLimit": "Risk limiti",
        "email": "E-posta",
        "phone": "Telefon",
        "iban": "IBAN",
        "notes": "Notlar"
      },
      "termsDays": "vade {{days}} gün",
      "paymentTermsValue": "{{days}} gün",
      "daysSuffix": "gün",
      "receipt": "Tahsilat gir",
      "payment": "Ödeme gir",
      "addInvoice": "Fatura ekle",
      "saved": "Cari kaydedildi",
      "taxNoWarning": "Vergi numarasının kontrol hanesi tutmuyor — yine de kaydedebilirsin.",
      "selectHint": "Soldan bir cari seç"
    },
    "invoices": {
      "title": "Faturalar",
      "purchase": "Alış",
      "sale": "Satış",
      "new": "Yeni fatura",
      "newPurchase": "Yeni alış faturası",
      "newSale": "Yeni satış faturası",
      "editTitle": "Fatura {{no}}",
      "summaryPurchase": "{{count}} alış faturası · açık {{open}} · indirilecek KDV {{vat}}",
      "summarySale": "{{count}} satış faturası · açık {{open}} · hesaplanan KDV {{vat}}",
      "stats": {
        "openPayable": "Açık borç",
        "paidThisMonth": "Bu ay ödenen",
        "inputVat": "İndirilecek KDV",
        "openReceivable": "Açık alacak",
        "overdue": "Vadesi geçen",
        "collectedThisMonth": "Bu ay tahsil",
        "outputVat": "Hesaplanan KDV"
      },
      "overdueCount": "{{count}} fatura",
      "columns": {
        "no": "Fatura no",
        "contact": "Cari",
        "date": "Tarih",
        "due": "Vade",
        "amount": "Tutar",
        "vat": "KDV",
        "status": "Durum"
      },
      "status": {
        "draft": "Taslak",
        "open": "Açık",
        "partially_paid": "Kısmi",
        "paid_purchase": "Ödendi",
        "paid_sale": "Tahsil edildi",
        "cancelled": "İptal",
        "overdue": "Gecikti"
      },
      "fields": {
        "no": "Fatura no",
        "noAuto": "Kaydedince otomatik ({{pattern}})",
        "date": "Fatura tarihi",
        "due": "Vade",
        "dueDays": "{{days}} gün",
        "currencyRate": "Para birimi · kur",
        "contact": "Cari",
        "notes": "Not"
      },
      "lines": "Kalemler",
      "lineColumns": {
        "item": "Kalem",
        "qty": "Miktar",
        "unit": "Birim",
        "price": "Birim fiyat",
        "discount": "İsk. %",
        "vat": "KDV",
        "total": "Tutar",
        "product": "Ürün",
        "productNone": "Ürün seçilmedi",
        "productSearch": "Ürün ara…"
      },
      "discountSuffix": "% isk.",
      "addLine": "+ Satır ekle",
      "needLine": "En az bir kalem gir",
      "attachments": "Ekler",
      "attach": "PDF / foto",
      "hasAttachment": "ek var",
      "totals": {
        "subtotal": "Ara toplam",
        "discount": "İskonto",
        "net": "Net toplam",
        "vat": "KDV",
        "vatAt": "KDV %{{pct}}",
        "total": "Toplam",
        "base": "₺ karşılığı"
      },
      "allocations": "Ödeme eşleştirme",
      "remaining": "Kalan",
      "rateFrozen": "Kur fatura tarihinde donduruldu · {{rate}}",
      "draft": "Taslak",
      "saveDraft": "Taslak",
      "post": "Faturayı kaydet",
      "cancelInvoice": "Faturayı iptal et",
      "cancelConfirm": "{{no}} iptal edilecek: {{total}}. Bu işlem geri alınamaz.",
      "saved": "Fatura kaydedildi",
      "empty": "Bu türde fatura yok. “Yeni fatura” ile ilk kaydı oluştur.",
      "csvNamePurchase": "alis-faturalari",
      "csvNameSale": "satis-faturalari",
      "searchPlaceholder": "Fatura no, cari ara…",
      "lockedPaid": "Ödemesi eşleşmiş faturanın satırları değiştirilemez.",
      "lineIncomplete": "{{n}}. satırın açıklaması ya da miktarı eksik — toplam bu satırı da içeriyor",
      "deleteDraft": "Taslağı sil",
      "deleteDraftConfirm": "Bu taslak fatura silinecek. Henüz kaydedilmiş bir hareketi yok.",
      "draftDeleted": "Taslak silindi",
      "matchedPayment": "Eşleşen ödeme",
      "advance": "Avans",
      "noAdvances": "Bu carinin eşleştirilecek avansı yok. Kasa ekranından tahsilat ya da ödeme gir.",
      "allocTooBig": "Eşleştirme fatura kalanını aşamaz — kalan {{amount}}",
      "allocLegNeeded": "Hesaptan çıkacak {{currency}} tutarını yaz",
      "allocLegTooBig": "Hesapta o kadar yok — kalan {{amount}}",
      "receipt": {
        "title": "Mal kabul",
        "badge": "{{count}} kalem stoğa alındı · {{date}}",
        "hint": "{{count}} satır stoğa alınacak. Birim maliyet faturadaki fiyattan (KDV hariç, iskonto düşülmüş) ve faturanın kurundan okunur.",
        "noItemLines": "Satırlara ürün bağlanmadığı için stoğa alınacak kalem yok.",
        "receivedHint": "Mal stoğa alındı. Birim maliyet bu faturadan hesaplandı.",
        "location": "Lokasyon",
        "date": "Kabul tarihi",
        "action": "Stoğa al",
        "undo": "Mal kabulü geri al",
        "done": "{{count}} kalem stoğa alındı.",
        "doneWithSkipped": "{{count}} kalem stoğa alındı, {{skipped}} satır atlandı (ürünsüz veya hizmet).",
        "undone": "{{count}} kalem stoktan geri alındı."
      }
    },
    "cash": {
      "title": "Kasa / banka",
      "accounts": "Hesaplar",
      "totalBase": "Toplam karşılık {{amount}}",
      "totalBaseMissingRate": "kuru bulunamayan hesap var",
      "addAccount": "+ Hesap ekle",
      "newAccount": "Yeni hesap",
      "editAccount": "Hesabı düzenle",
      "closed": "kapatıldı · {{date}}",
      "closedNoDate": "kapatıldı",
      "closedSubtitle": "Kapatılmış hesap · yalnızca geçmiş",
      "subtitle": "{{detail}} · bu ay {{count}} işlem",
      "lastMovement": "son hareket {{date}}",
      "importStatement": "Ekstre yükle",
      "csvName": "hesap-{{name}}",
      "searchPlaceholder": "İşlem, cari, kategori ara…",
      "newTx": "Yeni işlem",
      "columns": {
        "date": "Tarih",
        "type": "Tür",
        "description": "Açıklama",
        "category": "Kategori",
        "amount": "Tutar",
        "balance": "Bakiye"
      },
      "txTypes": {
        "receipt": "Tahsilat",
        "payment": "Ödeme",
        "transfer": "Virman",
        "expense": "Masraf",
        "income": "Gelir",
        "fee": "Masraf",
        "fx_diff": "Kur farkı"
      },
      "txForm": {
        "type": "İşlem türü",
        "account": "Hesap",
        "sourceAccount": "Kaynak hesap",
        "amount": "Tutar",
        "currency": "Para birimi",
        "partnerCurrencyNew": "{{currency}} ortak hesabı kaydederken açılır. Tutar {{currency}} olarak saklanır, TL karşılığı işlem kuruyla dondurulur.",
        "contactReceivable": "Cari (alacak)",
        "contactPayable": "Cari (borç)",
        "targetAccount": "Hedef hesap",
        "targetAmount": "Hedef hesaba geçen tutar",
        "vendor": "Tedarikçi / kişi",
        "relatedAccount": "İlgili hesap",
        "category": "Kategori",
        "note": "Not",
        "document": "Belge",
        "save": "İşlemi kaydet",
        "fxRate": "Kur (1 {{cur}} = ? ₺)",
        "fxLive": "anlık kur · {{source}}",
        "fxDirection": "Yön",
        "gain": "Kur farkı geliri",
        "loss": "Kur farkı gideri",
        "splitVat": "KDV’yi %{{pct}} olarak ayır ({{amount}})",
        "matchInvoices": "Açık faturalarla eşleştir",
        "noOpenInvoices": "Bu carinin açık faturası yok — işlem avans olarak kalır.",
        "unallocated": "Eşleşmeyen: {{amount}}",
        "vatRate": "KDV oranı",
        "accountLeg": "Hesaba düşen ({{currency}})",
        "beforeOpening": "Hesap {{date}} tarihinde açıldı — daha eski bir tarihe kayıt yapılamaz",
        "accountLegHint": "Farklı para birimli faturada ikinci kutu hesaptan çıkan {{currency}} tutarıdır; kur farkını program kendi yazar.",
        "accountLegRequired": "Farklı para birimli eşleştirmede hesaba düşen {{currency}} tutarını gir",
        "partnerTransferHint": "Ortağa iade veya ortaktan sermaye için Virman kullan.",
        "saved": "İşlem kaydedildi",
        "deleted": "İşlem silindi"
      },
      "empty": "Bu hesapta henüz işlem yok.",
      "noAccounts": "Henüz kasa/banka hesabı yok. İlk hesabı ekle.",
      "accountTypes": {
        "cash": "Kasa",
        "bank": "Banka",
        "payment_provider": "Ödeme kuruluşu",
        "partner": "Ortak hesabı"
      },
      "accountFields": {
        "name": "Hesap adı",
        "namePlaceholder": "Ziraat · TL vadesiz",
        "type": "Tür",
        "currency": "Para birimi",
        "openingBalance": "Açılış bakiyesi",
        "openingDate": "Açılış tarihi",
        "bankName": "Banka",
        "iban": "IBAN",
        "lockedHint": "Hesapta işlem var: para birimi, açılış bakiyesi ve tarihi artık değişmez. Düzeltmeyi işlemle yap."
      },
      "partnerNote": "negatif bakiye = şirketin ortağa borcu",
      "closeAccount": "Hesabı kapat",
      "closeAccountConfirm": "{{name}} kapatılacak. Kapalı hesaba yeni işlem girilemez, geçmiş kayıtlar durur.",
      "closeAccountNonZero": "Bakiyesi {{amount}} — kapatmadan önce virmanla sıfırlamak daha temiz.",
      "accountClosed": "Hesap kapatıldı",
      "reopenAccount": "Hesabı yeniden aç",
      "accountReopened": "Hesap yeniden açıldı",
      "accountSaved": "Hesap kaydedildi",
      "deleteTx": "İşlemi sil",
      "deleteTxConfirm": "{{date}} tarihli {{amount}} işlem silinecek. Eşleştirmeler kaldırılır.",
      "systemFx": "Kur farkı kaydı eşleştirmeden otomatik oluşur."
    },
    "partners": {
      "title": "Ortaklar",
      "lede": "Şirket kurulana kadar ve sonrasında ortakların kendi cebinden yaptığı harcamalar, şirkete aktardığı para ve iadeler.",
      "contributed": "Net katkı",
      "totalBase": "TL karşılığı",
      "approxToday": "≈ {{amount}} bugünkü kurla",
      "currencyLine": "{{amount}} · ≈ {{base}}",
      "share": "Pay",
      "fairShare": "Payına düşen",
      "difference": "Fark",
      "settlement": "Hesaplaşma önerisi",
      "settlementNone": "Ortaklar dengede — hesaplaşma gerekmiyor.",
      "pays": "{{from}} → {{to}}",
      "sharesInvalid": "Pay toplamı %100 değil. Ortak paylarını düzenle.",
      "editShares": "Payları düzenle",
      "addExpense": "Ortak harcaması ekle",
      "reimburse": "Ortağa iade (virman)",
      "capital": "Ortaktan şirkete para (virman)",
      "positive": "şirketin borcu",
      "negative": "ortağın borcu",
      "history": "Hareketler",
      "csvName": "ortak-hareketleri",
      "sharesSaved": "Paylar kaydedildi",
      "equalSplit": "eşit bölüşüm",
      "estimateNote": "Pay girilmemiş ortaklar kalan payı eşit bölüşür.",
      "breakdown": "Harcama kırılımı",
      "breakdownLede": "Ortakların kendi cebinden yaptığı masraflar, kategoriye göre · TL karşılığı işlem kuruyla",
      "allPartners": "Tüm ortaklar",
      "noExpenses": "Bu seçim için ortak masrafı yok.",
      "uncategorised": "Kategorisiz",
      "entries": "{{count}} kayıt",
      "costOfMoney": "Paranın maliyeti",
      "costOfMoneyLede": "Bu ay · yasal gider değil",
      "costOfMoneyNone": "Bu ay için hesaplanan maliyet yok.",
      "costOfMoneySetup": "Referans faizi gir"
    },
    "period": {
      "title": "Dönem özeti",
      "quarter": "{{q}}. çeyrek {{year}}",
      "vat": "KDV özeti",
      "vatNote": "hesaplanan vs indirilecek",
      "vatCards": {
        "out": "Hesaplanan KDV",
        "in": "İndirilecek KDV",
        "net": "Ödenecek KDV",
        "carry": "Devreden KDV"
      },
      "vatNotes": {
        "out": "kesilen satış faturalarından",
        "in": "alış faturaları ve masraflardan",
        "carryFrom": "{{month}} döneminden devir",
        "carryNone": "önceki dönemden devir yok",
        "carryOut": "sonraki döneme {{amount}} devrediyor",
        "due": "beyan son tarih {{date}}"
      },
      "byRate": "Oran bazında",
      "base": "Matrah",
      "rateDirections": {
        "out": "satış",
        "in": "alış ve masraf"
      },
      "rateExempt": "istisna",
      "expensesByCategory": "Kategori bazında gelir / gider",
      "cashflow": "Nakit akışı projeksiyonu",
      "cashflowRange": "{{count}} hafta · ₺",
      "cashflowNote": "Açık alacaklar − açık borçlar · tüm kasa ve banka hesapları TL karşılığıyla · Amazon ödemeleri ve planlı satın almalar Faz 7’de eklenir",
      "cashflowAria": "Haftalık kapanış bakiyesi",
      "thisWeek": "Bu hafta",
      "forecast": "Tahmin",
      "lowest": "En düşük nokta",
      "weekOf": "{{date}} haftası",
      "components": {
        "title": "Projeksiyon bileşenleri",
        "opening": "Açılış nakdi",
        "receivables": "Açık ticari alacaklar",
        "payables": "Açık ticari borçlar",
        "amazon": "Beklenen Amazon ödemeleri",
        "planned": "Planlanan satın almalar",
        "fixed": "Sabit giderler (maaş, SGK, enerji)",
        "net": "{{count}} hafta net"
      },
      "week": {
        "opening": "Hafta başı nakit",
        "inflow": "Beklenen tahsilat",
        "outflow": "Beklenen ödeme",
        "closing": "Hafta sonu nakit",
        "items": "Bu haftaya düşen açık kalemler",
        "noItems": "Bu haftaya düşen açık kalem yok; kapanış önceki haftalardan geliyor.",
        "noDue": "vade yok"
      },
      "exportTitle": "Muhasebeci dışa aktarımı",
      "exportCsv": "Dışa aktar (CSV)",
      "exportLater": "XLSX + belge ZIP’i Faz 7’de",
      "movements": "{{count}} hareket",
      "rows": {
        "cashMovements": "Kasa / banka hareketi",
        "withAttachment": "Belgesi ekli",
        "expenseTotal": "Masraf toplamı"
      },
      "csv": {
        "headers": {
          "date": "Tarih",
          "account": "Hesap",
          "type": "Tür",
          "direction": "Yön",
          "amount": "Tutar",
          "currency": "Para birimi",
          "rate": "Kur",
          "amountBase": "TL karşılığı",
          "vat": "KDV",
          "category": "Kategori",
          "contact": "Cari",
          "description": "Açıklama",
          "document": "Belge"
        },
        "in": "giriş",
        "out": "çıkış",
        "hasAttachment": "var",
        "fileName": "muhasebe-hareketler-{{from}}_{{to}}.csv"
      },
      "noData": "Bu dönemde kayıt yok.",
      "capitalCost": {
        "title": "Paranın maliyeti",
        "subtitle": "Ortakların şirkette duran parasının dönem maliyeti — yasal gider değil",
        "colPartner": "Ortak",
        "colAvgBase": "Ortalama bakiye",
        "colRate": "Oran",
        "colCost": "Maliyet",
        "total": "Dönem toplamı",
        "noRate": "oran yok",
        "noRateHint": "Bu para birimi için referans faiz girilmemiş; maliyet hesaplanmadı.",
        "empty": "Bu dönemde ortakların şirkette duran parası yok.",
        "setup": "Referans faizi gir",
        "notExpense": "Bu tutar muhasebe kayıtlarına ve KDV beyanına girmez; yalnızca yönetim raporudur.",
        "noFx": "kur yok",
        "noFxHint": "Bu para biriminin ay sonu kuru kayıtlı değil; maliyeti TL toplamına eklenmedi. Kur girildiğinde kendiliğinden hesaplanır.",
        "partial": "kısmi",
        "partialHint": "Oran ayın tamamını kapsamıyor; gösterilen oran, maliyetin işlediği günlerin bakiye ağırlıklı ortalaması."
      }
    },
    "validation": {
      "fxLoading": "Kur yükleniyor — birkaç saniye bekle.",
      "fxMissing": "Bu tarih için kur bulunamadı — kuru elle gir."
    },
    "txDetail": {
      "title": "İşlem ayrıntısı",
      "account": "Hesap",
      "rate": "Kur",
      "base": "TL karşılığı",
      "vat": "KDV",
      "enteredBy": "Giren",
      "enteredAt": "Kayıt zamanı",
      "document": "Belge",
      "openDocument": "Belgeyi aç",
      "noDocument": "Bu işleme belge eklenmemiş.",
      "editHint": "Tutar, hesap, kur ve KDV değişmez. Onları düzeltmek için işlemi silip yeniden gir.",
      "contactMatched": "Faturayla eşleşmiş — cariyi değiştirmek için önce eşleşmeyi kaldır.",
      "previewFailed": "Önizleme açılamadı — belgeyi yeni sekmede aç.",
      "delete": "İşlemi sil",
      "deleteTitle": "İşlem silinsin mi?",
      "deleteBody": "{{amount}} tutarındaki {{type}} kaydı silinecek. Bakiyeler güncellenir; kayıt denetim günlüğünde kalır.",
      "deleted": "İşlem silindi"
    }
  },
  "settings": {
    "title": "Ayarlar",
    "search": "Ayar ara…",
    "newBadge": "yeni",
    "sections": {
      "company": "Şirket",
      "users": "Kullanıcılar & roller",
      "currencies": "Para birimleri & kur",
      "taxes": "Vergiler",
      "categories": "Gelir / gider kategorileri",
      "units": "Birimler",
      "numbering": "Numaralandırma",
      "warehouses": "Depolar / lokasyonlar",
      "workCenters": "İş merkezleri",
      "amazon": "Amazon hesapları",
      "notifications": "Bildirim kuralları",
      "shortcuts": "Kısayollar",
      "infra": "Altyapı bütçesi",
      "audit": "Denetim günlüğü",
      "importExport": "İçe / dışa aktarma",
      "backup": "Yedek durumu",
      "stock": "Stok ve sayım",
      "capitalCost": "Sermaye maliyeti"
    },
    "ledes": {
      "company": "Belgelerde ve dışa aktarımlarda görünen kimlik bilgileri.",
      "users": "İki ortak tam erişimlidir. Operatör rolü maliyet ve fiyat görmez; muhasebeci yalnızca okur ve dışa aktarır.",
      "currencies": "Kur işlem anında dondurulur; raporlar sonradan yeniden hesaplanmaz.",
      "taxes": "KDV oranları. Oranlar muhasebeci onayıyla kesinleşir.",
      "categories": "Masraf ve gelir kayıtlarında seçilen kategoriler. “Mobilde” işaretli gider kategorileri Masraf ekle ekranında çip olarak görünür.",
      "units": "Ölçü birimleri, ondalık hassasiyetleri ve paket hiyerarşisi. Buradaki paket değerleri yeni ürünlerin varsayılanıdır; ürüne özel dönüşümler ürün kartında tutulur.",
      "numbering": "Belge serileri. Yıl başında sıra sıfırlanır.",
      "warehouses": "Kendi deponu lokasyon seviyesine kadar tanımla. Her Amazon pazar yeri için ayrı bir FBA deposu otomatik açılır — bu depoların stoğu yalnızca senkronla değişir.",
      "infra": "Barındırma kaynaklarının kullanımı. Eşik %80’i geçtiğinde Bugün ekranında uyarı çıkar.",
      "audit": "Her yazma işlemi kim, ne zaman, hangi kayıt bilgisiyle saklanır. Kayıtlar silinemez.",
      "shortcuts": "Masaüstünde her şey klavyeyle yapılabilir. Komut paleti tüm eylemlere tek yerden erişir.",
      "notifications": "Hangi olay kime, hangi kanaldan gider.",
      "backup": "Otomatik yedekler ve son geri yükleme testi.",
      "draft": "Bu bölüm ilgili modülle birlikte açılacak.",
      "importExport": "Ürün listesi ve açılış stoğu için içe aktarma sihirbazı, geçmiş yüklemeler ve şablonlar. Stok yalnızca hareketle değişir — açılış stoğu da hareket olarak yazılır.",
      "workCenters": "Üretim operasyonlarının yapıldığı hatlar ve makineler. Ürün ağacı operasyonları, kapasite takvimi ve gerçek maliyet bu kayıtlardan beslenir.",
      "stock": "Stok durumu eşikleri, sayım kuralları, geri alma süresi, maliyet yöntemi ve etiket varsayılanları. Değişiklikler yeni kayıtlara uygulanır; geçmiş hareketler yeniden hesaplanmaz.",
      "capitalCost": "Ortakların şirkete koyduğu paranın maliyeti: mevduat faizi referans alınarak günlük işletilir. Yönetim raporudur — yasal gider değildir, KDV ve muhasebe kayıtlarına girmez."
    },
    "company": {
      "legalName": "Unvan",
      "legalNameNote": "Fatura ve tekliflerde basılır",
      "brand": "Marka",
      "brandNote": "Ürün ve PDF şablonlarında",
      "taxNo": "Vergi no · daire",
      "address": "Adres",
      "addressPlaceholder": "OSB, Şehitkamil / Gaziantep",
      "reportingCurrency": "Raporlama para birimi",
      "saved": "Şirket bilgileri kaydedildi"
    },
    "fx": {
      "reportingNote": "Üst bardaki ₺/$ anahtarı",
      "transactionCurrencies": "İşlem para birimleri",
      "source": "Kur kaynağı",
      "sourceNote": "Ücretsiz, anahtarsız · yedek TCMB günlük XML",
      "autoFetch": "Anlık kur çekimi",
      "autoFetchNote": "Her kayıtta işlem anındaki kur alınır",
      "official": "Muhasebe kuru (TCMB)",
      "officialNote": "Mutabakat için resmî kur türü [[muhasebeci teyidi bekliyor]]",
      "officialAria": "TCMB kur türü",
      "buying": "Döviz alış",
      "selling": "Döviz satış",
      "current": "Güncel kurlar"
    },
    "users": {
      "permission": "Yetki",
      "write": "yazma",
      "read": "salt okuma",
      "none": "erişim yok",
      "users": "Kullanıcılar",
      "invite": "Davet gönder",
      "inviteTitle": "Kullanıcı davet et",
      "inviteSent": "Davet oluşturuldu",
      "inviteCreated": "Davet oluşturuldu",
      "inviteNotEmailed": "E-posta gönderilemedi (şirket e-postası henüz bağlı değil). Aşağıdaki bağlantıyı ortağına kendin ilet; bağlantı 7 gün geçerli.",
      "inviteLinkNote": "E-posta gönderilemezse bu bağlantıyı kendin ilet (7 gün geçerli):",
      "pending": "beklemede",
      "inviteValidUntil": "Davet bağlantısı {{date}} tarihine kadar geçerli",
      "active": "aktif",
      "lastSeen": "son giriş {{time}}",
      "neverSeen": "henüz giriş yok",
      "you": "sen",
      "changeRole": "Rolü değiştir",
      "matrix": {
        "stockView": "Stok görüntüleme",
        "stockMove": "Stok hareketi girme",
        "countOpen": "Sayım oturumu açma",
        "countApprove": "Sayım farkı onaylama",
        "poCreate": "Satın alma siparişi oluşturma",
        "poApprove": "Satın alma siparişi onaylama",
        "production": "Üretim emri yürütme",
        "costs": "Maliyet ve fiyat görme",
        "amazon": "Amazon ayarları",
        "accounting": "Fatura ve cari kaydı",
        "export": "Dönem dışa aktarımı"
      },
      "name": "Ad soyad"
    },
    "infra": {
      "db": "Veritabanı boyutu",
      "storage": "Belge deposu",
      "actions": "Actions dakikası",
      "used": "{{pct}} kullanıldı",
      "threshold": "eşik %80",
      "normal": "normal",
      "watch": "izlemede",
      "exceeded": "eşik aşıldı",
      "notMeasured": "henüz ölçülmedi",
      "dbNote": "Free tier 500 MB · uyarı 400 MB",
      "storageNote": "Free tier 1 GB · uyarı 800 MB",
      "actionsNote": "Özel depo 2.000 dk/ay · bütçe 800 dk",
      "minutesPerMonth": "{{value}} dk/ay",
      "tables": "En büyük tablolar",
      "rows": "{{count}} satır",
      "measuredAt": "ölçüm {{time}}"
    },
    "numbering": {
      "next": "sıradaki {{no}}"
    },
    "audit": {
      "time": "Zaman",
      "user": "Kullanıcı",
      "action": "İşlem",
      "record": "Kayıt",
      "insert": "{{table}} oluşturdu",
      "update": "{{table}} güncelledi",
      "delete": "{{table}} sildi",
      "system": "Sistem"
    },
    "tables": {
      "companies": "şirket",
      "company_members": "üye",
      "company_invitations": "davet",
      "contacts": "cari",
      "invoices": "fatura",
      "invoice_lines": "fatura satırı",
      "transactions": "işlem",
      "payment_allocations": "eşleştirme",
      "cash_accounts": "hesap",
      "expense_categories": "kategori",
      "settings": "ayar",
      "warehouses": "depo",
      "locations": "lokasyon",
      "tax_rates": "vergi oranı",
      "units": "birim",
      "number_sequences": "numara serisi",
      "notification_rules": "bildirim kuralı",
      "items": "ürün",
      "item_uoms": "ürün birimi",
      "item_groups": "ürün grubu",
      "boms": "ürün ağacı",
      "bom_lines": "bileşen",
      "bom_operations": "operasyon",
      "work_centers": "iş merkezi",
      "work_center_rates": "iş merkezi maliyeti",
      "machines": "makine",
      "warehouse_zones": "bölge",
      "lots": "lot",
      "stock_movements": "stok hareketi",
      "stock_counts": "sayım",
      "stock_count_lines": "sayım satırı",
      "labels": "etiket",
      "import_batches": "içe aktarım"
    },
    "shortcutGroups": {
      "general": "Genel",
      "new": "Yeni kayıt — n ardından",
      "table": "Tablo",
      "go": "Gezinme — g ardından"
    },
    "shortcuts": {
      "palette": "Komut paleti",
      "search": "Arama",
      "close": "Çekmece / modal kapat",
      "save": "Kaydet",
      "help": "Kısayol sayfası",
      "newExpense": "Masraf",
      "newInvoice": "Fatura",
      "newContact": "Cari",
      "goToday": "Bugün",
      "goAccounting": "Ön muhasebe",
      "goSettings": "Ayarlar",
      "rowDown": "Satır aşağı / yukarı",
      "helpNote": "Bu sayfayı her ekrandan açar."
    },
    "categories": {
      "expense": "Gider kategorileri",
      "income": "Gelir kategorileri",
      "add": "Ekle",
      "namePlaceholder": "Yeni kategori adı",
      "mobile": "Mobilde",
      "system": "Sistem",
      "archive": "Arşivle",
      "archived": "“{{name}}” arşivlendi — geçmiş kayıtlar etkilenmez",
      "saved": "Kategori kaydedildi",
      "rename": "Adı değiştir"
    },
    "notifRules": {
      "accounting": "Muhasebe bildirimleri",
      "later": "Diğer kurallar",
      "partner_activity": "Ortak para hareketi girdi",
      "partner_activityNote": "Diğer ortaklara · uygulama içi · anında",
      "invoice_due": "Fatura vadesi yaklaşıyor",
      "invoice_dueNote": "Vadeden {{count}} gün önce · her sabah 08:00",
      "invoice_overdue": "Fatura vadesi geçti",
      "invoice_overdueNote": "Vade günü geçince bir kez · uygulama içi",
      "low_stock": "Stok yeniden sipariş noktası altına indi",
      "low_stockNote": "Her iki ortak · uygulama + e-posta",
      "days_of_cover_low": "Karşılama günü hedefin altına indi",
      "days_of_cover_lowNote": "Sahip · günlük özet · eşik [[PLACEHOLDER]]",
      "po_overdue": "Satın alma siparişi gecikti",
      "po_overdueNote": "Her iki ortak · uygulama",
      "sync_failed": "Amazon senkron hatası",
      "sync_failedNote": "Sahip · uygulama + e-posta",
      "approval_requested": "Onay bekleyen kayıt",
      "approval_requestedNote": "İlgili ortak · anlık",
      "count_variance": "Sayım farkı eşiği aşıldı",
      "count_varianceNote": "%2 üzeri fark · sahip",
      "payout_received": "Amazon ödemesi alındı",
      "payout_receivedNote": "Her iki ortak · uygulama",
      "phase": "Faz {{phase}}"
    },
    "backup": {
      "daily": "Günlük tam yedek",
      "dailyNote": "Her gece 03:00 (TRT) · GitHub Actions · age ile şifreli · 90 gün saklanır",
      "none": "henüz yedek yok",
      "size": "Yedek boyutu",
      "restore": "Geri yükleme",
      "restoreNote": "docs/BACKUP_RESTORE.md — üç ayda bir test önerilir",
      "restoreValue": "dokümanda"
    },
    "units": {
      "packagingTitle": "Paket hiyerarşisi",
      "packagingNote": "Tüm ekranlardaki adet ↔ paket ↔ koli dönüşümü bu üç sayıdan türer.",
      "packQty": "Paket içi",
      "casePacks": "Koli içi",
      "napkinWeight": "Peçete ağırlığı",
      "bobbinNetKg": "Bobin net ağırlığı",
      "palletBobbins": "Palet içi bobin",
      "container40hc": "Konteyner (40HC)",
      "unitPieces": "adet",
      "unitPacks": "paket",
      "unitGramsPerPiece": "g/adet",
      "unitKg": "kg",
      "unitBobbins": "bobin",
      "unitPallets": "palet",
      "containerLine": "1×40HC = {{pallets}} palet = {{bobbins}} bobin = {{tons}} t = {{cases}} koli",
      "packagingWarning": "Değişiklik yalnızca yeni ürünlerin varsayılan dönüşümlerini etkiler. Mevcut ürünlerin paket ve koli içi adetleri ürün kartında durur; geçmiş hareketler yeniden hesaplanmaz.",
      "packagingSaved": "Paket hiyerarşisi kaydedildi",
      "listTitle": "Ölçü birimleri",
      "add": "Birim ekle",
      "edit": "Birimi düzenle — {{name}}",
      "colCode": "Kod",
      "colName": "Ad",
      "colDecimals": "Ondalık",
      "colUsage": "Kullanım",
      "colStatus": "Durum",
      "editAria": "Birimi düzenle",
      "inUse": "Kullanımda — {{count}} ürün biriminde",
      "inUseRefused": "‘{{name}}’ birimi {{count}} üründe kullanılıyor — pasif yapılamaz.",
      "code": "Kod",
      "codeHint": "Sistem içi kod: küçük harf, rakam ve alt çizgi. Kullanıldıktan sonra değiştirilemez.",
      "codePlaceholder": "ör. box",
      "shortName": "Kısa ad",
      "shortNamePlaceholder": "ör. kutu",
      "shortNameHint": "Tablolarda miktarın yanında görünür: 12 kutu",
      "shortNameEn": "Kısa ad (İngilizce)",
      "shortNameEnPlaceholder": "ör. box",
      "longName": "Açıklama",
      "longNamePlaceholder": "ör. Karton kutu",
      "precision": "Ondalık hassasiyet",
      "precisionNone": "Yok",
      "precisionWarning": "Hassasiyeti düşürmek mevcut miktarları yuvarlamaz; yalnızca yeni girişleri sınırlar.",
      "usageNote": "Kullanım notu",
      "usageNotePlaceholder": "ör. etiket, folyo",
      "usageNoteHint": "Nerede kullanıldığını hatırlatır.",
      "delete": "Birimi sil",
      "deleteBody": "‘{{name}}’ birimi silinecek. Hiçbir üründe kullanılmıyor.",
      "saved": "Birim kaydedildi",
      "overridesTitle": "Ürüne özel dönüşümler",
      "overridesNote": "şirket varsayılanından farklı olan ürünler",
      "overridesEmpty": "Tüm ürünler şirket varsayılanlarını kullanıyor.",
      "overrideItem": "Ürün",
      "overridePackQty": "Paket içi",
      "overrideCasePacks": "Koli içi",
      "overridePalletCases": "Palet içi",
      "overrideWeight": "Gramaj"
    },
    "warehouses": {
      "ownTitle": "Kendi depolarım",
      "fbaTitle": "FBA depoları",
      "otherTitle": "Diğer depolar",
      "add": "Depo ekle",
      "edit": "{{code}} deposunu düzenle",
      "editMarketplaces": "Pazar yerlerini düzenle",
      "openAria": "{{code}} deposunu aç",
      "allowsNegative": "negatif stoka izinli",
      "back": "← Depolar",
      "emptyTitle": "Henüz depo yok",
      "emptyBody": "Stok tutabilmek için en az bir depo tanımla.",
      "fbaEmpty": "Henüz FBA deposu yok. Satış yaptığın pazar yerlerini seçtiğinde otomatik açılır.",
      "fbaEmptyAction": "Pazar yerlerini seç",
      "code": "Kod",
      "codeHint": "Lokasyon kodlarının ön eki olur — ör. D3-A-01. Hareket gördükten sonra değiştirilemez.",
      "codeTaken": "Bu kod başka bir depoda kullanılıyor.",
      "name": "Ad",
      "type": "Tür",
      "typeHint": "FBA depoları pazar yeri seçimiyle açılır.",
      "country": "Ülke",
      "address": "Adres",
      "matrixLabel": "Stok matrisi etiketi",
      "matrixLabelHint": "Eldeki stok tablosunda sütun başlığı olur.",
      "allowNegative": "Negatif stoka izin ver",
      "allowNegativeNote": "Kapalıyken bu depodan eldekinden fazla çıkış yapılamaz. Açıksa eksi bakiye kırmızı görünür ve Bugün ekranında uyarı çıkar.",
      "active": "Aktif",
      "deactivateBlocked": "{{code}} deposunda stok var — pasif yapmadan önce stoğu transfer et.",
      "deactivateBlockedItems": "{{code}} deposunda {{count}} üründe stok var — pasif yapmadan önce stoğu transfer et.",
      "typeLockedNote": "Depo hareket gördü: kod ve tür değiştirilemez.",
      "delete": "Depoyu sil",
      "deleteTitle": "Depo silinsin mi?",
      "deleteBody": "{{code}} deposu silinecek. Depoda hiç hareket yok; {{count}} lokasyon da silinir.",
      "saved": "Depo kaydedildi",
      "deleted": "{{code}} deposu silindi",
      "identity": {
        "type": "Tür",
        "country": "Ülke",
        "address": "Adres",
        "matrixLabel": "Stok matrisi etiketi",
        "negative": "Negatif stok",
        "negativeOn": "açık",
        "negativeOff": "kapalı",
        "locations": "Lokasyon",
        "locationsValue": "{{active}} aktif · {{inactive}} pasif",
        "items": "Eldeki kalem",
        "itemsValue": "{{items}} ürün · {{lots}} lot",
        "lastCount": "Son sayım",
        "never": "hiç"
      },
      "zones": {
        "eyebrow": "Bölgeler",
        "all": "Tümü",
        "add": "+ Bölge ekle",
        "edit": "{{code}} bölgesi",
        "new": "Bölge ekle",
        "editAria": "Bölgeyi düzenle",
        "code": "Kod",
        "codePlaceholder": "H",
        "name": "Ad",
        "namePlaceholder": "Hammadde",
        "matrixColumn": "Stok matrisinde ayrı sütun",
        "matrixColumnNote": "Açıksa eldeki stok tablosunda bu bölge kendi sütununda görünür.",
        "matrixLabel": "Matris etiketi",
        "matrixLabelPlaceholder": "D1 Ham",
        "deleteBlocked": "Bu bölgede {{count}} lokasyon var — önce lokasyonları başka bölgeye taşı.",
        "none": "Bölgesiz",
        "saved": "Bölge kaydedildi"
      },
      "locations": {
        "searchPlaceholder": "Lokasyon ara…",
        "add": "Lokasyon ekle",
        "bulkAdd": "Toplu ekle",
        "edit": "{{code}}",
        "new": "Lokasyon ekle",
        "selected": "{{count}} lokasyon seçildi",
        "printLabels": "Etiket yazdır",
        "printLabelsCount": "Etiket yazdır ({{count}})",
        "labelsPending": "Etiket ekranı bu fazın ilerleyen turunda açılacak",
        "deactivate": "Pasif yap",
        "clearSelection": "Seçimi kaldır",
        "colCode": "Kod",
        "colName": "Açıklama",
        "colZone": "Bölge",
        "colType": "Tür",
        "colItems": "Kalem",
        "colLastCount": "Son sayım",
        "colStatus": "Durum",
        "code": "Kod",
        "codeHint": "Yalnızca A–Z, 0–9 ve tire. Türkçe karakter kullanma.",
        "codeTaken": "Bu lokasyon kodu zaten var.",
        "zone": "Bölge",
        "type": "Tür",
        "quarantineHint": "Karantinadaki stok satış ve planlamada kullanılabilir sayılmaz.",
        "name": "Açıklama",
        "namePlaceholder": "ör. Mamul rafı A, 2. göz",
        "active": "Aktif",
        "deactivateBlocked": "{{code}}’de {{count}} üründe stok var ({{qty}}). Pasif yapmadan önce stoğu transfer et.",
        "deactivateBlockedItems": "{{code}}’de {{count}} üründe stok var. Pasif yapmadan önce stoğu transfer et.",
        "negative": "negatif",
        "stockHere": "Bu lokasyondaki stok",
        "seeAllStock": "Tümünü stokta gör →",
        "delete": "Lokasyonu sil",
        "saved": "Lokasyon kaydedildi",
        "emptyTitle": "Bu depoda lokasyon yok",
        "emptyBody": "Stok depo düzeyinde tutulur; raf takibi için lokasyon ekle.",
        "emptyAction": "Toplu lokasyon ekle",
        "noResult": "‘{{q}}’ ile eşleşen lokasyon yok.",
        "noResultAction": "Aramayı temizle",
        "footNote": "Doğal sıralama · D1-A-2 < D1-A-10 · depo varsayılan lokasyonu listelenmez",
        "footCount": "{{visible}} / {{total}} lokasyon · {{active}} aktif · {{inactive}} pasif",
        "bulkTitle": "Toplu lokasyon ekle",
        "bulkPrefix": "Önek",
        "bulkStart": "Başlangıç",
        "bulkEnd": "Bitiş",
        "bulkPad": "Hane",
        "bulkPad2": "2 hane (01)",
        "bulkPad3": "3 hane (001)",
        "bulkPreviewTitle": "Önizleme",
        "bulkPreviewCount": "{{count}} lokasyon oluşturulacak",
        "bulkPreviewEmpty": "Geçerli bir aralık gir.",
        "bulkConflicts": "{{count}} tanesi zaten var, atlanacak: {{codes}}",
        "bulkFixRange": "Aralığı düzelt",
        "bulkSubmit": "{{count}} lokasyon oluştur",
        "bulkCreated": "{{count}} lokasyon oluşturuldu"
      },
      "marketplaces": {
        "title": "FBA pazar yerleri",
        "subtitle": "Seçili her pazar yeri için bir FBA deposu açılır.",
        "regionNA": "NA bölgesi",
        "regionEU": "EU bölgesi",
        "hasStock": "{{code}}’de {{qty}} stok var — kaldırılamaz.",
        "saved": "Pazar yerleri güncellendi"
      },
      "matrix": {
        "title": "Stok matrisi sütunları",
        "note": "Eldeki stok ekranındaki depo sütunlarının sırası",
        "reorderAria": "Sırayı değiştir",
        "moveUp": "Yukarı taşı",
        "moveDown": "Aşağı taşı",
        "visible": "görünür",
        "saved": "Sütun sırası kaydedildi"
      }
    },
    "workCenters": {
      "title": "İş merkezleri",
      "add": "İş merkezi ekle",
      "edit": "{{name}}",
      "usedIn": "{{count}} aktif ürün ağacında kullanılıyor",
      "missingCostTitle": "Saatlik maliyet eksik",
      "missingCostBody": "{{names}} için saatlik maliyet girilmedi. Standart ve gerçek maliyet bu iş merkezlerinin makine payını 0 ₺ sayar.",
      "missingCostAction": "Maliyetleri gir",
      "colWorkCenter": "İş merkezi",
      "colType": "Tür",
      "colCapacity": "Kapasite",
      "colNominalRate": "Nominal hız",
      "colHourlyCost": "Saatlik maliyet",
      "colBomUsage": "Ürün ağacı",
      "colStatus": "Durum",
      "subtotalCount": "{{count}} iş merkezi",
      "subtotalHours": "{{hours}} sa/gün",
      "notEntered": "girilmedi",
      "emptyTitle": "Henüz iş merkezi yok",
      "emptyBody": "Ürün ağacı operasyonları için en az bir iş merkezi tanımla.",
      "types": {
        "cutting": "Kesim",
        "folding": "Katlama",
        "foil_print": "Varak baskı",
        "digital_print": "Dijital baskı",
        "packing": "Paketleme",
        "palletising": "Paletleme",
        "qc": "Kalite kontrol",
        "other": "Diğer"
      },
      "sectionGeneral": "Genel",
      "sectionCapacity": "Kapasite",
      "sectionCost": "Maliyet",
      "sectionMachines": "Makineler",
      "sectionUsage": "Kullanım",
      "code": "Kod",
      "codePlaceholder": "M2",
      "codeTaken": "Bu kod başka bir iş merkezinde kullanılıyor.",
      "name": "Ad",
      "namePlaceholder": "Katlama M2",
      "type": "Tür",
      "location": "Üretim lokasyonu",
      "locationNone": "Seçilmedi",
      "locationHint": "Üretim çıktısı ve backflush tüketimi bu lokasyona göre yazılır.",
      "capacityHours": "Günlük kapasite",
      "capacitySuffix": "sa/gün",
      "hourSuffix": "sa",
      "workingDays": "Çalışma günleri",
      "days": {
        "mon": "Pzt",
        "tue": "Sal",
        "wed": "Çar",
        "thu": "Per",
        "fri": "Cum",
        "sat": "Cmt",
        "sun": "Paz"
      },
      "nominalRate": "Nominal hız",
      "nominalRateHint": "Planlama ve verim raporu bu hızı hedef kabul eder.",
      "hourlyCost": "Saatlik makine maliyeti",
      "hourlyCostEmpty": "Girilmedi — maliyet hesaplarında 0 ₺ sayılır.",
      "labourRate": "Varsayılan işçilik ücreti",
      "labourRateHint": "Ürün ağacı operasyonlarında varsayılan olarak önerilir.",
      "depreciation": "Aylık amortisman (makineler)",
      "costMasked": "Operatör rolünde maliyet alanları maskelenir.",
      "addMachine": "+ Makine ekle",
      "activeBoms": "Aktif ürün ağacı",
      "plannedThisWeek": "Bu hafta planlanan",
      "deactivate": "Pasif yap",
      "deactivateBlocked": "{{name}} {{count}} aktif ürün ağacında kullanılıyor — önce bu operasyonları başka bir iş merkezine taşı.",
      "delete": "Sil",
      "saved": "İş merkezi kaydedildi"
    },
    "stock": {
      "statusTitle": "Stok durumu",
      "criticalRatio": "Kritik stok eşiği",
      "criticalRatioNote": "Eldeki stok yeniden sipariş noktasının bu oranına inince ‘kritik’ görünür.",
      "negativeStock": "Negatif stok",
      "negativeStockNote": "Depo bazında ayarlanır.",
      "negativeStockLink": "Depolar / lokasyonlar →",
      "negativeStockOff": "{{count}} depoda kapalı",
      "negativeStockOn": "{{count}} depoda açık",
      "countTitle": "Sayım",
      "countTolerance": "Fark toleransı",
      "countToleranceNote": "Bu oranı aşan farklar onaya düşer ve bildirim gider.",
      "countBlind": "Kör sayım varsayılan",
      "countBlindNote": "Sayan kişi beklenen miktarı görmez.",
      "countSelfApproval": "Kendi sayımını onaylama",
      "countSelfApprovalNote": "Kapalıyken sayımı yapan kişi onaylayamaz; diğer ortak onaylar. Şirket sahibi bu kuralı geçebilir.",
      "movementsTitle": "Hareketler",
      "undoSeconds": "Geri alma süresi",
      "undoSecondsNote": "Kaydedilen hareket bu süre içinde geri alınabilir.",
      "backdateMaxDays": "Geriye tarihli kayıt sınırı",
      "backdateMaxDaysNote": "Mobil ve çevrimdışı kayıtlar en fazla bu kadar geriye tarihlenir; ortaklar web’de daha eskiye yazabilir.",
      "requirePhoto": "Fire ve hurdada fotoğraf zorunlu",
      "costingTitle": "Maliyet",
      "costingBadge": "sahip · ortak · muhasebeci",
      "costingMethod": "Maliyet yöntemi",
      "costingMethodNote": "Yöntem şirket genelinde tektir.",
      "costingMovingAverage": "Hareketli ortalama",
      "costingFifo": "FIFO",
      "overheadPct": "Genel gider oranı",
      "overheadPctNote": "Standart maliyete eklenir. Girilene kadar 0 sayılır.",
      "driftWarnPct": "Standart maliyet sapma uyarısı",
      "driftWarnPctNote": "Ürün ağacından hesaplanan maliyet bu orandan fazla saparsa ürün kartında uyarı çıkar.",
      "itemDefaultsTitle": "Ürün varsayılanları",
      "bomBaseQty": "Ürün ağacı taban miktarı",
      "napkinStockUnit": "Peçete stok birimi",
      "bobbinStockUnit": "Bobin stok birimi",
      "itemDefaultsNote": "Yeni ürünlerde eldeki stok bu birimle gösterilir.",
      "labelsTitle": "Etiketler",
      "labelsBadge": "{{dpi}} dpi termal",
      "labelsFootNote": "Etikette QR · lot no · ürün adı · SKU · miktar + birim · üretim tarihi basılır. SKT ve GTIN bu fazda yok.",
      "labelLogo": "Logoyu bas",
      "labelMargin": "Kenar boşluğu",
      "labelPrinterDpi": "Yazıcı çözünürlüğü",
      "labelPrinterDpiNote": "[[Zebra ZD230 sınıfı]] termal — yazıcı henüz alınmadı.",
      "labelQrEcc": "QR hata düzeltme",
      "labelQrEccNote": "Yüksek seviye yıpranmış etikette okumayı kolaylaştırır.",
      "labelCopies": "Varsayılan kopya",
      "mobileTitle": "Mobil",
      "mobileShowCost": "Ürün kartında maliyeti göster",
      "mobileShowCostNote": "Yalnızca maliyet görebilen rollerde; operatör hiçbir zaman görmez.",
      "openingTitle": "Açılış stoğu",
      "openingBadgeOpen": "açık",
      "openingFootNote": "Kilitten sonra düzeltmeler yalnızca sayım ile yapılır.",
      "openingLabel": "Açılış stoğu kilidi",
      "openingOpenNote": "Açılış stoğu hareketleri ve içe aktarımı açık. Canlıya geçince kilitle.",
      "openingLock": "Açılış stoğunu kilitle",
      "openingLockedChip": "kilitli · {{date}} · {{who}}",
      "openingLockedAt": "kilitli · {{date}}",
      "openingLockedNote": "Düzeltmeler sayım ile yapılır.",
      "openingLockedInfo": "İçe / dışa aktarma bölümündeki Açılış stoğu kartı pasif; hareket kaydında ‘Açılış stoğu’ sebebi seçilemez.",
      "openingLockOwnerOnly": "Yalnızca şirket sahibi kilitleyebilir.",
      "openingConfirmTitle": "Açılış stoğu kilitlensin mi?",
      "openingConfirmBody": "Kilitledikten sonra ‘Açılış stoğu’ sebebiyle hareket yazılamaz ve açılış içe aktarımı kapanır; düzeltmeler sayımla yapılır.",
      "openingConfirmSummary": "{{warehouses}} depo · {{counts}} sayım oturumu · {{value}}",
      "openingConfirmWarehouses": "Kilitlenecek depo",
      "openingConfirmWarehousesValue": "{{count}} depo · {{codes}}",
      "openingConfirmCounts": "Açılış sayım oturumu",
      "openingConfirmMovements": "Açılış hareketi",
      "openingConfirmMovementsValue": "{{count}} hareket",
      "openingConfirmValue": "Kilitlenecek toplam değer",
      "openingConfirm": "Kilitle",
      "openingLocked": "Açılış stoğu kilitlendi",
      "openingLockedServer": "Açılış stoğu kilitlendi — düzeltme için sayım kullanın",
      "placeholderBadge": "yer tutucu",
      "placeholderHint": "Bu değer henüz onaylanmadı; sistem varsayılanı kullanılıyor.",
      "notEntered": "girilmedi",
      "phase7": "Faz 7",
      "saved": "Stok ayarları kaydedildi",
      "saveFailed": "Kaydedilemedi. Bağlantını kontrol edip yeniden dene.",
      "suffixDays": "gün",
      "suffixSeconds": "sn",
      "suffixMm": "mm",
      "suffixDpi": "dpi",
      "suffixPieces": "adet"
    },
    "capitalCost": {
      "explainer": "Ortakların şirkette duran parası bir mevduat hesabında dursaydı faiz kazanırdı. Bu bölümde o faizi referans alıyoruz: her ortağın şirkete koyduğu para günlük olarak aşağıdaki orana göre işletilir ve “paranın maliyeti” olarak raporlanır.",
      "points": {
        "base": "Hesap tabanı: her ortağın ortak hesabındaki alacağı — cebinden yaptığı masraflar ve şirkete koyduğu sermaye dahil. Ortak şirkete borçluysa maliyet işlemez.",
        "method": "Yöntem: basit faiz, ACT/365. Her gün o günkü bakiyeye o gün yürürlükteki oran uygulanır; bileşik faiz yoktur.",
        "currency": "Her para birimi kendi oranıyla işler. Dolar bakiye için dolar mevduat oranı girilmezse o para biriminde maliyet hesaplanmaz ve ekran bunu söyler.",
        "notExpense": "Bu tutar yasal gider değildir: kasa, banka, cari ve KDV kayıtlarına girmez, muhasebeci dışa aktarımında ayrı durur. Nakdi sermaye artışı faiz indirimi (KVK 10/1-ı) bambaşka bir hesaptır; mali müşavirine danış."
      },
      "ratesTitle": "Referans faiz oranları",
      "add": "Oran ekle",
      "empty": "Henüz referans oran girilmedi. Bir oran girilene kadar paranın maliyeti hesaplanmaz.",
      "missingRate": "Şu para birimleri için referans oran yok: {{currencies}}. O paraların maliyeti hesaplanmıyor.",
      "colCurrency": "Para birimi",
      "colFrom": "Geçerlilik başlangıcı",
      "colRate": "Yıllık oran",
      "colNote": "Kaynak / not",
      "inForce": "yürürlükte",
      "drawerTitle": "Referans faiz oranı",
      "fromHint": "Bu tarihten itibaren geçerlidir; önceki günler eski oranla işlemeye devam eder.",
      "rateHint": "Bankaların vadeli mevduat faizi, yıllık brüt. Örn. 42,5.",
      "noteHint": "Oranın nereden alındığı — sonradan “bu sayı nereden geldi” sorusunun cevabı.",
      "notePlaceholder": "Garanti · 32 gün vadeli · 1 Eki 2026",
      "saved": "Oran kaydedildi",
      "deleted": "Oran silindi",
      "deleteTitle": "Oran silinsin mi?",
      "deleteBody": "Bu oran kaldırılırsa kapsadığı günler bir önceki orana döner ve geçmiş raporlar yeniden hesaplanır.",
      "future": "ileri tarihli"
    }
  },
  "states": {
    "emptyTitle": "Burada henüz bir şey yok",
    "error": "Veri yüklenemedi",
    "errorBody": "Sunucuya ulaşılamıyor. Bağlantını kontrol et — kaydedilmemiş bir şey kaybolmadı.",
    "offline": "Çevrimdışı — kayıtlar kuyrukta",
    "offlineQueue": "{{count}} bekleyen",
    "readOnly": "Salt okunur",
    "readOnlyTitle": "Salt okunur erişim — muhasebeci rolü",
    "readOnlyBody": "Kayıt oluşturamaz veya değiştiremezsin. Dışa aktarım ve ekstre indirme açık.",
    "readOnlyExport": "Dönem dışa aktar",
    "forbidden": "Bu bölümü görme yetkin yok",
    "forbiddenBody": "Rolün: {{role}}. Ortağından yetki isteyebilirsin."
  },
  "mobile": {
    "tabs": {
      "today": "Bugün",
      "stock": "Stok",
      "scan": "Tara",
      "production": "Üretim",
      "more": "Daha fazla",
      "accounting": "Muhasebe"
    },
    "pullToRefresh": "Son senkron {{time}} · aşağı çekerek yenile",
    "tapToRefresh": "Son senkron {{time}} · yenilemek için dokun",
    "more": {
      "title": "Daha fazla",
      "notifications": "Bildirimler",
      "settings": "Ayarlar",
      "expense": "Masraf ekle",
      "approvals": "Onaylar",
      "amazon": "Amazon özeti",
      "count": "Sayım",
      "receiving": "Mal kabul",
      "fba": "FBA sevkiyat",
      "documents": "Şirket evrakları"
    },
    "settings": {
      "account": "Hesap",
      "company": "Şirket",
      "preferences": "Tercihler",
      "language": "Dil",
      "reportingCurrency": "Raporlama para birimi",
      "darkMode": "Koyu tema",
      "darkModeNote": "sistem ayarını izler",
      "darkModeWeb": "tarayıcıda telefonun tema ayarını izler",
      "bigText": "Büyük yazı",
      "bigTextNote": "atölye modunda",
      "notifications": "Bildirimler",
      "stockAlerts": "Stok uyarıları",
      "approvalRequests": "Onay istekleri",
      "syncErrors": "Amazon senkron hataları",
      "dailyDigest": "Günlük özet",
      "dailyDigestNote": "her akşam 20:00",
      "signOut": "Çıkış yap",
      "signOutPending": "Bu cihazda gönderilmemiş kayıt: {{count}} (masraf, stok hareketi, sayım). Çıkış yaparsan silinir. Önce bağlanıp göndermek için Vazgeç’e dokun.",
      "signOutPendingSome": "Bu cihazda gönderilmemiş kayıt: {{count}} (masraf, stok hareketi, sayım). Çıkış yaparsan senin eklediğin {{mine}} tanesi silinir; kalanı eski sürümden kaldığı için cihazda durur. Önce bağlanıp göndermek için Vazgeç’e dokun.",
      "signOutPendingKept": "Bu cihazda gönderilmemiş kayıt: {{count}} (masraf, stok hareketi, sayım). Hepsi eski sürümden kalmış; çıkış yapsan da silinmez, cihazda durur. Önce bağlanıp göndermek için Vazgeç’e dokun.",
      "signOutCounts": "Bu cihazda devam eden sayım: {{count}} oturum, {{lines}} sayılmış satır. Çıkış yaparsan sayım bu cihazdan silinir — gönderilmemiş satırlar da gider."
    },
    "expense": {
      "title": "Masraf ekle",
      "receiptPhoto": "fiş\nfotoğrafı",
      "takePhoto": "Fotoğraf çek",
      "pickGallery": "Galeriden seç",
      "pickFile": "Dosya seç (PDF / görsel)",
      "amount": "Tutar",
      "currency": "Para birimi",
      "category": "Kategori",
      "account": "Ödeyen hesap",
      "note": "Not",
      "notePlaceholder": "Ne için ödendi?",
      "splitVat": "KDV’yi %{{pct}} olarak ayır ({{amount}})",
      "save": "Masrafı kaydet",
      "saved": "Masraf kaydedildi",
      "queued": "Çevrimdışı — masraf kuyruğa alındı",
      "queueFailed": "Masraf bu cihaza kaydedilemedi (depolama dolu olabilir). Ekranı kapatma; bağlantı gelince tekrar kaydet.",
      "fxMissing": "{{currency}} kuru bulunamadı; kur servisine de ulaşılamadı. Kuru web’de gir, sonra tekrar gönder.",
      "photoFailed": "Fotoğraf alınamadı. Galeriden seçmeyi dene ya da masrafı fotoğrafsız kaydet.",
      "pickFailed": "Fotoğraf seçilemedi. Yeniden dene ya da masrafı fotoğrafsız kaydet.",
      "cameraDenied": "Kamera izni verilmedi. Galeriden seçebilirsin.",
      "noAccount": "Önce web’den bir kasa veya ortak hesabı tanımla."
    },
    "entry": {
      "noRights": "İşlem girmek için sahip ya da ortak yetkisi gerekir. Bu rolde kayıtları görebilir, ekleyemezsin.",
      "today": "bugün",
      "todayCta": "Bugüne dön",
      "prevMonth": "Önceki ay",
      "nextMonth": "Sonraki ay",
      "weekdayShort": {
        "mon": "Pt",
        "tue": "Sa",
        "wed": "Ça",
        "thu": "Pe",
        "fri": "Cu",
        "sat": "Ct",
        "sun": "Pz"
      },
      "pickAccount": "Hesap seç",
      "pickTargetAccount": "Hedef hesap seç",
      "pickContact": "Cari seç",
      "pickCategory": "Kategori seç",
      "searchContact": "Cari adı, vergi no, şehir",
      "searchCategory": "Kategori ara",
      "noResults": "Sonuç yok: “{{query}}”",
      "noContacts": "Kayıtlı cari yok. “Yeni cari” ile ekleyebilirsin.",
      "noCategories": "Bu türde kategori yok. Web’de Ayarlar → Gelir / gider kategorileri’nden ekle; sık kullandıklarını “Mobilde” işaretlersen burada çip olarak çıkar.",
      "categoriesLoading": "Kategoriler yükleniyor…",
      "categoriesFailed": "Kategoriler yüklenemedi — hangi kategorilerin olduğu bilinmiyor.",
      "otherCategories": "Diğer…",
      "newContactOffline": "Yeni cari için bağlantı gerekir — cari kaydı kuyruğa alınmaz. Bağlanınca ekleyebilirsin.",
      "targetAmountHint": "Kaynak ve hedef para birimi farklı: hedef hesaba geçen tutarı sen yazarsın, kur farkını program kendi işler.",
      "fxDiffNote": "Kur farkı hesaptan para çıkarmaz: tutar yalnızca TL karşılığını düzeltir, yön kazanç mı gider mi olduğunu söyler.",
      "fxPastDate": "{{currency}} hesap — geçmiş tarihli kayıt o günün kurunu ister. O gün için kayıtlı kur yoksa işlem kuyrukta bekler; kuru web’de Ayarlar → Para birimleri & kur’dan girersin.",
      "fxMissingForDate": "{{date}} için {{currency}} kuru kayıtlı değil; günün kuru sonradan çekilemez. Kuru web’de Ayarlar → Para birimleri & kur’dan gir, sonra tekrar gönder.",
      "matchLoading": "Açık faturalar yükleniyor…",
      "matchFailed": "Açık fatura listesi yüklenemedi — bu carinin açık faturası olup olmadığı bilinmiyor. Tekrar dene; eşleştirmeden kaydedersen işlem avans olarak kalır.",
      "matchOffline": "Çevrimdışı — açık fatura listesi güncel olmayabilir, bu yüzden eşleştirme kapalı. İşlem avans olarak kuyruğa girer; faturayla eşleştirmeyi bağlantı gelince yaparsın.",
      "matchRateUnknown": "{{currency}} hesapla farklı para birimli faturayı telefonda eşleştiremezsin: kur ancak işlem gönderilirken belirlenir. İşlemi avans olarak kaydet, eşleştirmeyi web’de yap.",
      "advance": "avans olarak kalır, sonra faturayla eşleştirilebilir",
      "overAllocated": "Faturalara dağıtılan tutar işlem tutarını {{amount}} aşıyor — satırlardaki tutarları küçült.",
      "queued": "Çevrimdışı — işlem kuyruğa alındı",
      "queuedAdvance": "Çevrimdışı — işlem avans olarak kuyruğa alındı. Faturayla eşleştirmeyi bağlantı gelince yap.",
      "queuedMatched": "Çevrimdışı — işlem eşleştirmesiyle kuyruğa alındı. Fatura bu arada kapandıysa kayıt kuyrukta bekler; “Bekleyen değişiklikler”den görürsün.",
      "queueFailed": "İşlem bu cihaza kaydedilemedi (depolama dolu olabilir). Ekranı kapatma; bağlantı gelince tekrar kaydet."
    },
    "scanSoon": "Barkod tarayıcı Faz 2’de stok modülüyle açılır.",
    "scan": {
      "subtitle": "QR veya barkod okutun",
      "offlineShort": "Çevrimdışı",
      "manual": "El ile gir",
      "torch": "Fener",
      "history": "Son taramalar",
      "historyEmpty": "Henüz tarama yok.",
      "clear": "Temizle",
      "onHand": "Eldeki",
      "location": "Lokasyon",
      "cost": "Maliyet",
      "hidden": "gizli",
      "shelves": "raf",
      "costHiddenNote": "Operatör rolünde maliyet alanları gizlenir.",
      "costHiddenA11y": "Maliyet gizli — operatör rolü",
      "cameraA11y": "Kamera görüntüsü — barkodu çerçeveye hizala",
      "maybe": "Bunu mu arıyordun?",
      "lotBlocked": "Bu lot karantinada — çıkış yapılamaz.",
      "screenSoon": "Bu ekran Faz 2’nin devamında açılır.",
      "notFound": "Kayıt bulunamadı",
      "notFoundBody": "“{{code}}” bir ürün, lot, lokasyon veya siparişle eşleşmedi.",
      "notFoundBarcode": "“{{code}}” barkodu hiçbir ürüne bağlı değil.",
      "docMissing": "“{{code}}” bu şirkette bulunamadı.",
      "rescan": "Tekrar tara",
      "linkBarcode": "Barkodu ürüne bağla",
      "linkBarcodeLater": "Barkod bağlama telefonda Faz 2’nin devamında açılır. Barkodu bilgisayardan ürün kartına ekleyebilirsin.",
      "mismatch": "Bu bir {{found}} etiketi — {{expected}} okut.",
      "counter": "{{count}} okutuldu",
      "done": "Bitti",
      "offlineData": "çevrimdışı · {{time}} verisi",
      "offlineRecord": "Çevrimdışı — bu kayıt bağlantı gelince yüklenir.",
      "resolveError": "Sorgu başarısız.",
      "manualTitle": "Kodu el ile gir",
      "manualPlaceholder": "Lot, SKU, lokasyon veya sipariş no",
      "actions": {
        "transfer": "Transfer",
        "count": "Sayım",
        "printLabel": "Etiket yazdır",
        "useInProduction": "Üretimde kullan",
        "stockCard": "Stok kartı",
        "transferFrom": "Buradan transfer",
        "viewContents": "İçeriği gör",
        "receive": "Mal kabul",
        "shopFloor": "Atölye modu",
        "continueCount": "Sayıma devam et"
      },
      "facts": {
        "items": "Ürün",
        "lots": "Lot",
        "lastMove": "Son hareket"
      },
      "kinds": {
        "item": "ürün",
        "lot": "lot",
        "location": "lokasyon",
        "document": "belge",
        "purchase_order": "sipariş",
        "production_order": "üretim emri",
        "stock_count": "sayım",
        "stock_movement": "hareket",
        "fba_shipment": "FBA sevkiyatı"
      },
      "kindTitle": {
        "purchase_order": "Satın alma siparişi",
        "production_order": "Üretim emri",
        "stock_count": "Sayım oturumu",
        "stock_movement": "Stok hareketi",
        "fba_shipment": "FBA sevkiyatı"
      },
      "phaseLocked": {
        "receive": "Mal kabul Faz 3 ile açılır.",
        "shopFloor": "Atölye modu Faz 5 ile açılır.",
        "fba": "FBA sevkiyatı Faz 4 ile açılır."
      },
      "permission": {
        "body": "Tarayıcıyı kullanmak için kamera izni gerekli. İzin vermezsen barkodu el ile girebilirsin.",
        "allow": "İzin ver",
        "blockedBody": "Kamera izni kapalı. Ayarlar’dan açabilir ya da barkodu el ile girebilirsin.",
        "openSettings": "Ayarları aç",
        "unavailable": "Kamera açılamadı. Barkodu el ile girebilirsin."
      },
      "unknown": "Kod tanınmadı: {{code}}"
    },
    "label": {
      "later": "Etiket yazdırma Faz 2’nin devamında açılır.",
      "laterBody": "100 × 50 mm termal etiket — QR, lot numarası, ürün ve miktar — sonraki turda gelecek. O zamana kadar bu ekrandan etiket çıkmaz; sayım ve transfer etkilenmez."
    },
    "stock": {
      "title": "Stok",
      "searchPlaceholder": "Ürün, SKU, lot veya lokasyon ara",
      "scan": "Barkod tara",
      "clear": "Aramayı temizle",
      "filters": {
        "all": "Tümü",
        "finished": "Mamul",
        "raw": "Hammadde",
        "packaging": "Ambalaj"
      },
      "resultCount": "{{count}} sonuç · “{{query}}”",
      "itemCount": "{{count}} ürün",
      "matchLot": "lot {{lot}}",
      "rowA11yQty": "eldeki {{qty}} {{unit}}",
      "rowA11yHint": "Ürün kartını açar",
      "onHand": "Eldeki",
      "locations": "Lokasyon",
      "shelves": "raf",
      "lots": "Lot",
      "activeLots": "aktif",
      "noLots": "lot yok",
      "byLocation": "Lokasyona göre",
      "lotsTitle": "Lotlar",
      "movements": "Son hareketler",
      "noMovements": "Henüz hareket yok",
      "perUnit": "{{factor}} {{base}}/{{unit}}",
      "fba": "FBA {{code}}",
      "actions": {
        "transfer": "Transfer",
        "adjust": "Düzeltme",
        "label": "Etiket"
      },
      "costHidden": "Maliyet ve satış fiyatı gizli",
      "roleSuffix": "{{role}} rolü",
      "unitCost": "Birim maliyet",
      "stockValue": "Stok değeri",
      "status": {
        "low": "Düşük",
        "critical": "Kritik",
        "negative": "Negatif"
      },
      "empty": "Henüz ürün yok",
      "emptyBody": "Ürünler web’de Ürünler ekranından eklenir.",
      "noResults": "Sonuç yok: “{{query}}”",
      "noResultsFilter": "Bu filtrede ürün yok",
      "noResultsBody": "SKU, ürün adı, lot veya lokasyon koduyla ara ya da barkodu tara.",
      "scanAction": "Tara",
      "loadError": "Stok yüklenemedi",
      "noCache": "Stok verisi bu cihazda yok",
      "noCacheBody": "Bağlantı gelince bir kez açman yeterli; sonra çevrimdışı da aranabilir.",
      "noAccess": "Bu bölüm rolüne kapalı",
      "noAccessBody": "Stok ekranlarını sahip, ortak ve operatör rolleri görür.",
      "itemGone": "Ürün artık listede yok"
    },
    "movement": {
      "transfer": "Transfer",
      "adjust": "Düzeltme",
      "stepOf": "Adım {{n}} / {{count}} · {{step}}",
      "steps": {
        "item": "Ürün",
        "source": "Kaynak lokasyon",
        "sourceAdjust": "Lokasyon",
        "qty": "Miktar",
        "target": "Hedef lokasyon",
        "reason": "Sebep",
        "note": "Foto ve not",
        "confirm": "Onay"
      },
      "cancelTransfer": "Transfer iptal edilsin mi?",
      "cancelAdjust": "Düzeltme iptal edilsin mi?",
      "cancelBody": "Girdiğin bilgiler silinecek.",
      "cancelConfirm": "İptal et",
      "scanned": "tarandı",
      "picked": "seçildi",
      "qtyLabelTransfer": "Transfer edilecek miktar",
      "qtyLabelAdjust": "Düzeltme miktarı",
      "remaining": "Kalan lokasyonda",
      "remainingAdjust": "Yeni lokasyon miktarı",
      "continueTo": "Devam et · {{step}}",
      "clear": "Temizle",
      "deleteKey": "Sil",
      "decimalKey": "Virgül",
      "over": "Lokasyonda {{available}} var — fazlası aktarılamaz.",
      "negativeAhead": "Stok eksiye düşecek.",
      "availableChanged": "Lokasyondaki miktar güncellendi: {{available}}.",
      "directionOut": "Düş",
      "directionIn": "Ekle",
      "scanItem": "Ürün veya lot okut",
      "scanLocation": "Lokasyon okut",
      "recent": "Son kullanılanlar",
      "otherLocations": "Diğer lokasyonlar",
      "noStock": "Bu ürünün stoğu yok.",
      "noStockBody": "Mal kabul veya sayım ile stok girildikten sonra hareket girilebilir.",
      "sameLocation": "Kaynak ve hedef aynı lokasyon olamaz.",
      "fbaHint": "FBA depolarına gönderim FBA sevkiyat ile yapılır.",
      "defaultOnly": "Henüz raf tanımlı değil — hareket deponun varsayılan lokasyonuna yazılır.",
      "noLocations": "Depo ve lokasyon tanımlı değil",
      "noLocationsBody": "Web’de Ayarlar › Depolar ekranından tanımlanır.",
      "lotRequired": "Bu ürün lot takipli — lot seçmelisin.",
      "lotBlocked": "Bloke veya karantinadaki lottan çıkış yapılamaz.",
      "reasonNotAllowed": "Bu sebep bu rolde kullanılamaz — başka bir sebep seç.",
      "locationInactive": "Bu lokasyon pasif.",
      "insufficient": "Kaynak lokasyonda yeterli stok yok (şu an {{available}}).",
      "notePlaceholder": "Açıklama gir…",
      "noteRequired": "Bu sebep için not gerekli",
      "photoRequired": "Bu sebep için fotoğraf gerekli",
      "addPhoto": "Fotoğraf ekle",
      "noReasons": "Bu tür için elle girilebilen sebep yok.",
      "preview": "Sonuç önizleme",
      "totalUnchanged": "Toplam eldeki değişmez",
      "total": "Toplam eldeki",
      "valueImpact": "Değer etkisi",
      "reasonLine": "Sebep: {{reason}}",
      "noteLine": "Not: {{note}}",
      "saveTransfer": "Transferi kaydet",
      "saveAdjust": "Düzeltmeyi kaydet",
      "savedTransfer": "Transfer kaydedildi · {{no}}",
      "savedAdjust": "Düzeltme kaydedildi · {{no}}",
      "replayed": "Bu hareket zaten kaydedilmişti · {{no}}",
      "queuedTransfer": "Çevrimdışı — transfer kuyruğa alındı",
      "queuedAdjust": "Çevrimdışı — düzeltme kuyruğa alındı",
      "queueFailed": "Hareket bu cihaza kaydedilemedi (depolama dolu olabilir). Ekranı kapatma; bağlantı gelince tekrar dene.",
      "undone": "Geri alındı",
      "undoFailed": "Geri alınamadı — ters hareket gerekiyor.",
      "photoLeftBehind": "Hareket kaydedildi ama fotoğraf yüklenemedi.",
      "offlineNote": "Çevrimdışı kaydedilen hareket, bağlantı gelince sunucuda yeniden denetlenir."
    },
    "comingSoon": "Faz {{phase}} ile gelir",
    "notifGroups": {
      "today": "Bugün",
      "yesterday": "Dün",
      "week": "Bu hafta",
      "older": "Daha eski"
    },
    "noNotifications": "Bildirim yok. Vadesi yaklaşan fatura ve onay istekleri burada görünür.",
    "markAllRead": "Tümünü okundu say",
    "markRead": "Okundu say",
    "offline": "Çevrimdışı — kayıtlar kuyrukta",
    "sending": "Kuyruk gönderiliyor",
    "queueStuck": "Gönderilemeyen kayıt var",
    "queueTitle": "Bekleyen değişiklikler",
    "queueCount": "{{count}} kayıt",
    "queueNote": "Formlar kullanılabilir kalır. Bağlantı gelince kuyruk sırayla gönderilir; başkası aynı kaydı değiştirmişse çakışma listesi açılır.",
    "queueBlocked": "Otomatik denemeler durdu. Sorunu web’de düzeltip “Şimdi gönder”e dokun ya da kaydı sil.",
    "queueEmpty": "Bekleyen kayıt yok.",
    "sendNow": "Şimdi gönder",
    "discard": "Kuyruktan sil",
    "discardConfirm": "Bu kayıt gönderilmeden silinecek. Emin misin?",
    "lastError": "Son hata: {{message}}",
    "magicHomeScreen": "Ana ekrana eklenen uygulamada bağlantı ile giriş çalışmaz: e-postadaki bağlantı Safari’de açılır ve buraya dönmez. Şifrenle giriş yap; şifren yoksa web uygulamasında “Şifremi unuttum” ile belirle.",
    "signInLinkFailed": "Giriş bağlantısı burada tamamlanamadı. Bağlantı yalnızca istendiği tarayıcıda, 15 dakika içinde ve bir kez çalışır. Yeni bağlantı iste ya da şifrenle giriş yap.",
    "companyUnavailable": {
      "title": "Şirket bilgileri yüklenemedi",
      "body": "Bağlantı yok ya da sunucuya ulaşılamıyor. Bağlantı gelince kendiliğinden yüklenir."
    },
    "languageNames": {
      "tr": "Türkçe",
      "en": "English"
    },
    "pushLater": "Anlık bildirimler sonraki fazda açılır",
    "switchCompany": "Şirket seç",
    "expenseFx": "{{currency}} hesap — kur kayıt tarihindeki TCMB/elle girilen kurdan alınır",
    "photoAttached": "fotoğraf eklendi",
    "photoMissing": "Fiş fotoğrafı bu cihazda artık yok. Kaydı kuyruktan silip yeniden gir.",
    "removePhoto": "Fotoğrafı kaldır",
    "noCategory": "Mobilde gösterilecek gider kategorisi yok. Web’de Ayarlar → Gelir / gider kategorileri’nden “Mobilde” işaretle.",
    "today": {
      "tryAccounts": "TL hesaplar",
      "overdueCount": "{{count}} vadesi geçen",
      "moreOverdue": "{{count}} uyarı daha var — hepsini web’de gör",
      "remaining": "kalan {{amount}}",
      "daysLate": "{{count}} gün",
      "laterTiles": "Stok, üretim ve Amazon kutucukları ilgili modüllerle (Faz 2–6) eklenir."
    },
    "count": {
      "title": "Sayım",
      "blind": "kör sayım",
      "openMode": "açık sayım",
      "progress": "{{counted}} / {{total}} sayıldı",
      "location": "Lokasyon",
      "locationsTitle": "Lokasyonlar",
      "locationCount": "{{count}} lokasyon",
      "locationWord": "lokasyon",
      "lineWord": "satır",
      "diffWord": "fark",
      "diffLines": "Farklı satır",
      "diffCount": "{{count}} satır",
      "noDiff": "fark yok",
      "finishCta": "Bu lokasyonu bitir",
      "submitCta": "Sayımı gönder",
      "qtyLabel": "Sayılan miktar",
      "save": "Kaydet",
      "saveNext": "Kaydet · sonraki",
      "saveClose": "Kaydet · bitir",
      "clearCount": "Sayımı temizle",
      "expected": "beklenen {{qty}}",
      "chipMoved": "hareket oldu",
      "chipRecount": "yeniden say",
      "chipUnexpected": "listede yoktu",
      "status": {
        "pending": "Sayılmadı",
        "counting": "Devam ediyor · {{counted}}/{{total}}",
        "done": "Bitti",
        "doneDiffs": "Bitti · {{count}} fark",
        "recount": "Yeniden say"
      },
      "scanItem": "Ürün veya lot tara",
      "scanLocation": "Lokasyon etiketi tara",
      "whichLot": "Hangi lot?",
      "uncountedTitle": "{{count}} satır sayılmadı",
      "uncountedBody": "Sayılmayan satırlar bulunamadı (0) olarak mı işaretlensin?",
      "uncountedBack": "Geri dön ve say",
      "uncountedZero": "0 olarak işaretle",
      "finished": "{{code}} bitti · {{lines}} satır, {{diffs}} fark",
      "reopened": "{{code}} yeniden açıldı",
      "submitted": "{{no}} onaya gönderildi",
      "submitQueued": "Çevrimdışı — sayım bağlantı gelince onaya gönderilecek",
      "withdrawn": "{{no}} geri çekildi",
      "undoFinish": "{{code}} bitti",
      "undoSubmit": "{{no}} onaya gönderildi",
      "pendingApproval": "Onay bekliyor",
      "pendingApprovalBody": "Ortağın masaüstünde farkları inceleyecek.",
      "recountTitle": "Yeniden sayım istendi",
      "movedTitle": "Sayım sırasında bu lokasyonda hareket oldu",
      "movedBody": "{{count}} satır etkilendi",
      "otherCounter": "Bu lokasyonu {{name}} sayıyor — aynı satırlar iki kez sayılabilir.",
      "otherCounterAnon": "Bu lokasyonu başka bir cihaz sayıyor — aynı satırlar iki kez sayılabilir.",
      "lineOverwritten": "{{code}} · {{name}}: bu satırı başka bir cihaz saymış, sunucudaki miktar kaldı. Rafı birlikte kontrol edin.",
      "clearIgnored": "{{code}} · {{name}}: temizleme sunucuya yetişmedi, miktar sunucuda kaldı. Doğru miktarı yaz.",
      "emptyLocation": "Bu lokasyonda beklenen ürün yok",
      "emptyLocationBody": "Bulduğun ürünleri tarayarak ekle.",
      "notOnDevice": "Bu sayım bu cihazda yok",
      "notOnDeviceBody": "Bağlantı gelince açabilirsin.",
      "noRightsBody": "Sayım için operatör, ortak veya sahip rolü gerekli.",
      "storageFailed": "Kayıt cihaza yazılamadı — depolama dolu olabilir.",
      "elsewhereTitle": "Bu ürün {{code}} lokasyonunda.",
      "elsewhereGo": "{{code}} lokasyonuna geç",
      "locationOutside": "{{code}} bu sayımda yok",
      "unexpectedTitle": "Beklenmeyen ürün",
      "unexpectedBody": "{{name}} bu lokasyonun listesinde yok. Sayıma ekleyip miktar girebilirsin.",
      "unexpectedLotRequired": "{{name}} lot takipli — önce lot etiketini okut.",
      "unexpectedAdd": "Sayıma ekle",
      "startTitle": "Sayım başlat",
      "startCta": "Sayımı başlat",
      "startOffline": "Sayım başlatmak için bağlantı gerekli. Başlamış bir sayıma çevrimdışı devam edebilirsin.",
      "startFailed": "Sayım başlatılamadı.",
      "startReplay": "{{no}} zaten başlatılmıştı.",
      "warehouse": "Depo",
      "locations": "Lokasyonlar",
      "scopeAll": "Tüm lokasyonlar ({{count}})",
      "scopePick": "Lokasyon seç",
      "zoneAll": "{{count}} lokasyonu seç",
      "zoneClear": "seçimi kaldır",
      "zoneDefault": "Varsayılan",
      "mode": "Sayım türü",
      "modeBlind": "Kör sayım",
      "modeOpen": "Açık sayım",
      "modeBlindHint": "Beklenen miktarlar sayılana kadar gizli kalır.",
      "modeOpenHint": "Beklenen miktarlar satırlarda görünür.",
      "assignee": "Sayan",
      "assigneeMe": "Ben",
      "resumeTitle": "Devam eden sayım",
      "resumeCta": "Devam et",
      "queueKind": "Sayım",
      "queueSubmitKind": "Sayım gönderimi",
      "queueSubmitTail": "onaya gider",
      "closed": {
        "approved": "Onaylandı — farklar stoğa işlendi.",
        "cancelled": "Sayım iptal edildi.",
        "reverted": "Sayım geri alındı."
      },
      "a11yLot": "lot {{lot}}",
      "a11yUncounted": "sayılmadı",
      "a11yCounted": "sayılan {{qty}} {{unit}}",
      "a11yDiff": "fark {{diff}} (%{{pct}})",
      "a11yHint": "Miktar girmek için dokun"
    },
    "conflicts": {
      "title": "Çakışma listesi",
      "lede": "Sen çevrimdışıyken başkası aynı stoğu değiştirdi. Her satır için ne yapılacağını seç.",
      "empty": "Çakışma kalmadı",
      "needsOnline": "Çakışmaları çözmek için bağlantı gerekli.",
      "moved": "Sayım sırasında {{qty}} {{unit}} hareket oldu",
      "recount": "Yeniden say",
      "keep": "Olduğu gibi gönder",
      "kept": "Sayım olduğu gibi gönderilecek.",
      "insufficient": "{{code}} lokasyonunda artık {{qty}} var",
      "sendAvailable": "{{qty}} olarak gönder"
    },
    "queueEntries": "{{count}} kayıt bu satırda",
    "queueWaiting": "Önceki kayıt bekleniyor",
    "queueConflictRow": "Çakışma — çözmek için dokun",
    "queueConflicts": "{{count}} kayıt çakıştı",
    "queueConflictsCta": "Çakışma listesini aç ({{count}})",
    "queueResolve": "Çakışmayı çöz",
    "discardCount": "Bu lokasyonun {{count}} satırlık sayımı bu cihazdan silinecek.",
    "accounting": {
      "title": "Ön Muhasebe",
      "lede": "Cariler, faturalar, kasa ve ortaklar — webdekiyle aynı rakamlar",
      "sections": "Bölümler",
      "cashOnHand": "Kasa & banka",
      "receivable": "Net alacak",
      "payable": "Net borç",
      "contactCount": "{{count}} cari",
      "accountCount": "{{count}} hesap",
      "openInvoices": "{{count}} açık fatura",
      "readOnly": "Fatura, cari kartı, ayarlar ve dönem kapanışı webde yapılır.",
      "openOnWeb": "Webde aç",
      "contacts": {
        "empty": "Henüz cari yok",
        "emptyBody": "Cariler web’de Ön Muhasebe › Cariler ekranından eklenir.",
        "noResults": "Sonuç yok: “{{query}}”",
        "noResultsFilter": "Bu filtrede cari yok",
        "noResultsBody": "Cari adı, vergi no, e-posta, telefon veya şehirle ara.",
        "noOpenItems": "Açık kalem yok"
      },
      "cash": {
        "noAccountsBody": "İlk kasa/banka hesabı webde açılır.",
        "closedSection": "Kapalı hesaplar",
        "loadMore": "Daha fazla yükle",
        "contactSearch": "Cari adı ara…",
        "contactMore": "{{count}} cari daha — aramayla daralt",
        "dateHint": "GG.AA.YYYY",
        "dateInvalid": "Tarihi GG.AA.YYYY olarak yaz",
        "noCategories": "Bu türde kategori yok; kategoriler webdeki ayarlardan açılır.",
        "offlineWrite": "Düzeltme ve silme bağlantı ister; bu işler kuyruğa alınmaz.",
        "transferDeleteOut": "Virman, parayı çıkaran hesabın defterinden silinir.",
        "fxDiffManual": "Kur farkında düzeltilecek alan yok: tutarı ya da yönü değiştirmek için kaydı sil ve yeniden gir.",
        "documentAdd": "Belge ekle",
        "documentReplace": "Belgeyi değiştir",
        "documentReplaceNote": "Yeni belge eskisinin yerini alır; eski dosya arşivde kalır.",
        "documentOffline": "Belgeyi açmak için bağlantı gerekir.",
        "documentLinkCopied": "Belge bağlantısı kopyalandı — {{minutes}} dakika geçerli.",
        "documentFailed": "Belge açılamadı"
      },
      "invoices": {
        "subtitle": "{{count}} fatura · {{open}} açık",
        "empty": "Bu türde fatura yok",
        "emptyBody": "Faturalar webde oluşturuluyor; girildikleri anda buraya düşer.",
        "paidSplit": "{{paid}} ödendi · {{remaining}} kalan",
        "collectedSplit": "{{paid}} tahsil edildi · {{remaining}} kalan",
        "qtyAtPrice": "{{qty}} × {{price}}",
        "lineDiscount": "%{{pct}} iskonto",
        "noPayments": "Henüz eşleşen ödeme yok"
      },
      "partners": {
        "lede": "Kim ne koydu, kim kime ne ödeyecek",
        "baseNote": "Payına düşen, fark ve hesaplaşma TL karşılığı üzerinden hesaplanır; döviz satırları işlem kuruyla çevrilmiştir.",
        "empty": "Ortak kaydı yok",
        "emptyBody": "Ortak harcamaları ve sermaye hareketleri webde kaydedilince burada görünür.",
        "accounts": "Ortak hesapları",
        "costSetupWeb": "Referans faizi webdeki ayarlardan girilir."
      },
      "period": {
        "webOnly": "12 haftalık nakit akışı projeksiyonu ve muhasebeci dışa aktarımı webde kalır."
      }
    },
    "documents": {
      "moreNote": "Yükle, aç, paylaş ya da cihaza indir",
      "count": "{{count}} belge",
      "searchPlaceholder": "Belge, dosya adı veya not ara",
      "all": "Tümü",
      "actions": "İşlemler",
      "details": "Künye",
      "noResults": "Sonuç yok: “{{query}}”",
      "noResultsFilter": "Bu klasörde belge yok",
      "noResultsBody": "Belge adı, dosya adı ya da notla ara.",
      "pickFailed": "Dosya seçilemedi",
      "tooBig": "Bu dosya {{size}} — en çok {{mb}} MB yüklenebilir.",
      "badType": "Bu dosya türü yüklenemiyor: .{{ext}}",
      "unknownType": "Dosyanın türü anlaşılamadı — uzantısı olan bir dosya seç.",
      "uploadTitle": "Belgeyi yükle",
      "uploadFolder": "Hangi klasöre?",
      "uploading": "Yükleniyor — büyük dosya sürebilir, uygulamadan çıkma.",
      "foldersOnWeb": "Yeni klasör webdeki Evraklar ekranından açılır.",
      "offlineWrite": "Belge yüklemek ve değiştirmek için bağlantı gerekir; bu işler kuyruğa alınmaz.",
      "readOnly": "Bu rolde belge yükleyemez ya da değiştiremezsin.",
      "notFound": "Belge artık listede yok",
      "notFoundBody": "Arşivlenmiş ya da başka biri kaldırmış olabilir.",
      "openFailed": "Belge açılamadı",
      "shareFailed": "Paylaşım açılamadı",
      "saveFailed": "Belge indirilemedi",
      "saveHint": "Paylaşım sayfasındaki “Dosyalara Kaydet” ile telefona kaydedilir.",
      "savedWeb": "Belge indiriliyor",
      "linkCopied": "Bağlantı kopyalandı — {{minutes}} dakika geçerli",
      "linkShared": "Dosya değil bağlantı paylaşıldı — {{minutes}} dakika boyunca bağlantıyı açan herkes belgeyi görebilir.",
      "shareWebNote": "Tarayıcıda dosya yerine {{minutes}} dakika geçerli bir bağlantı paylaşılır.",
      "imageFailed": "Bu görüntü uygulamada açılamadı",
      "imageFailedBody": "Telefonun kendi görüntüleyicisi bu türü açabilir.",
      "openOutside": "Cihazda aç",
      "zoomHint": "Yakınlaştırmak için iki parmakla aç",
      "closeViewer": "Görüntüyü kapat",
      "edit": "Düzenle",
      "editTitle": "Belgeyi düzenle",
      "titleLabel": "Belge adı",
      "validUntilLabel": "Geçerlilik tarihi",
      "validUntilHint": "GG.AA.YYYY",
      "validUntilInvalid": "Tarihi GG.AA.YYYY olarak yaz",
      "saved": "Belge güncellendi"
    }
  },
  "validation": {
    "required": "Bu alan zorunlu",
    "email": "Geçerli bir e-posta gir",
    "number": "Geçerli bir sayı gir (ör. 1.234,56)",
    "positive": "Sıfırdan büyük bir değer gir",
    "date": "Geçerli bir tarih gir",
    "currency": "Para birimi seç",
    "taxNo": "Vergi no 10, TCKN 11 haneli olmalı",
    "iban": "IBAN geçersiz",
    "passwordLength": "Şifre en az 12 karakter olmalı",
    "category": "Kategori seç",
    "contact": "Cari seç",
    "targetAccount": "Hedef hesabı seç",
    "sameAccount": "Kaynak ve hedef hesap aynı olamaz",
    "colourHex": "Renk kodu #RRGGBB biçiminde olmalı",
    "integer": "Sıfırdan büyük bir tam sayı gir",
    "percent": "0 ile 100 arasında bir yüzde gir",
    "code": "Kodda yalnızca A–Z, 0–9 ve tire kullan",
    "codeTaken": "Bu kod zaten kullanılıyor",
    "unitCode": "Yalnızca küçük harf, rakam ve alt çizgi kullan",
    "sku": "SKU büyük harf ya da rakamla başlamalı; harf, rakam, nokta, alt çizgi ve tire kullanılabilir",
    "skuTaken": "Bu SKU zaten var",
    "gtin": "Barkod geçersiz (EAN-8, UPC-12, EAN-13 ya da GTIN-14)",
    "barcodeTaken": "Bu barkod başka bir üründe kullanılıyor",
    "qtyNotIntegral": "Miktar temel birimde ({{unit}}) tam sayı olmuyor",
    "unitUnknown": "Bu birim üründe tanımlı değil",
    "hours": "Günlük kapasite 0–24 saat arasında olmalı",
    "rangeOrder": "Bitiş başlangıçtan küçük olamaz",
    "rangeTooLarge": "Tek seferde en fazla {{count}} lokasyon",
    "hsCode": "GTİP 4803 ya da 4803.00.90 biçiminde olmalı"
  },
  "glyphs": {
    "title": "Türkçe karakter testi",
    "sample": "Çağrı Işıkoğlu şöyle dedi: “İğneyi önce kendine batır.” — ç ğ ı İ ö ş ü · Ç Ğ I İ Ö Ş Ü",
    "mono": "SAS-2026-0091 · ÜE-2026-0418 · PEC-26-0871 · 1.234,56 ₺"
  },
  "notifications": {
    "title": "Bildirimler",
    "empty": "Bildirim yok. Ortağın bir hareket girdiğinde veya fatura vadesi yaklaştığında burada görünür.",
    "markAllRead": "Tümünü okundu say",
    "unread": "{{count}} okunmamış"
  },
  "stock": {
    "matrix": {
      "crumb": "Eldeki stok matrisi",
      "title": "Eldeki stok",
      "subtitle": "{{items}} ürün · {{locations}} lokasyon",
      "addMovement": "Hareket ekle",
      "view": "Kayıtlı görünüm: {{name}}",
      "views": {
        "all": "Tümü",
        "critical": "Kritik izleme",
        "save": "Görünümü kaydet…"
      },
      "size": "Ebat: {{value}}",
      "colour": "Renk: {{value}}",
      "all": "tümü",
      "selected": "{{count}} seçili",
      "legend": "Karşılama günü renk skalası:",
      "legendLater": "Karşılama günü: Faz 6 ile gelir",
      "legendSr": "Karşılama günü koyudan açığa: 10 gün ve altı, 11–20 gün, 21–30 gün, 31–45 gün, 46–70 gün, 70 günden fazla.",
      "col": {
        "item": "Ürün",
        "unit": "Birim",
        "total": "Toplam",
        "cover": "Karş.",
        "coverTitle": "Karşılama günü (tahmin)"
      },
      "coverLater": "Karşılama günü satış tahmininden hesaplanır — Planlama (Faz 6) ile gelir.",
      "coverAria": "Karşılama günü {{days}} gün, tahmin",
      "coverAriaNone": "Karşılama günü hesaplanamıyor — tahmin Faz 6 ile gelir",
      "columns": "Sütunlar",
      "columnsTitle": "Sütunlar",
      "columnsLocked": "Ürün ve Toplam sütunları her zaman görünür.",
      "lots": "LOTLAR · {{name}}",
      "showLots": "Lotları göster",
      "hideLots": "Lotları gizle",
      "lotCol": {
        "lot": "Lot",
        "location": "Lokasyon",
        "note": "Not",
        "date": "Tarih",
        "qty": "Miktar"
      },
      "noLotTracking": "lot takibi yok",
      "noStock": "Bu üründe stok yok.",
      "lotsError": "Lotlar yüklenemedi.",
      "footerValue": "Toplam stok değeri",
      "footerFiltered": "Filtrelenen stok değeri",
      "empty": "Henüz stokta ürün yok. Açılış stoğunu içe aktararak başla.",
      "importOpening": "Açılış stoğunu içe aktar",
      "emptyFiltered": "Bu filtrelerle eşleşen ürün yok.",
      "clearFilters": "Filtreleri temizle",
      "error": "Stok yüklenemedi",
      "movedBy": "{{name}} bu üründe hareket kaydetti",
      "exportName": "aslen-ops-eldeki-stok",
      "csv": {
        "status": "Durum",
        "cover": "Karşılama günü",
        "value": "Stok değeri ({{currency}})"
      }
    },
    "panel": {
      "tabs": {
        "general": "Genel",
        "stock": "Stok",
        "cost": "Maliyet",
        "movements": "Hareketler"
      },
      "totalOnHand": "Toplam eldeki",
      "inBase": "= {{qty}}",
      "cover": "Karşılama günü",
      "days": "gün",
      "coverLater": "Faz 6 ile gelir",
      "distribution": "Lokasyon dağılımı",
      "valueByColumn": "Depo bazında stok değeri",
      "distributionEmpty": "Bu üründe stok yok.",
      "specs": "Künye",
      "spec": {
        "sizeFold": "Ebat / kat",
        "gsm": "Gramaj",
        "packaging": "Paketleme",
        "bobbinYield": "Bobin verimi",
        "reorderPoint": "Yeniden sipariş noktası",
        "standardCost": "Standart maliyet",
        "amazon": "Amazon eşleşme",
        "amazonLater": "Amazon eşleşmeleri Faz 4 ile gelir",
        "width": "Genişlik",
        "bobbinWeight": "Bobin ağırlığı",
        "leadTime": "Tedarik süresi",
        "measure": "Ölçü",
        "sku": "SKU",
        "type": "Tür",
        "barcode": "Barkod",
        "baseUnit": "Temel birim",
        "stockUnit": "Stok birimi",
        "lotTracked": "Lot takibi",
        "shelfLife": "Raf ömrü",
        "lastMove": "Son hareket",
        "avgCost": "Ortalama maliyet",
        "stockValue": "Stok değeri"
      },
      "on": "açık",
      "off": "kapalı",
      "unlimited": "sınırsız",
      "dayCount": "{{count}} gün",
      "gsmValue": "{{gsm}} g/m² · {{weight}} g/adet",
      "packagingValue": "{{pack}} adet/paket · {{packs}} paket/koli = {{pieces}} adet",
      "bobbinYieldValue": "1 bobin {{kg}} kg ≈ {{cases}} {{unit}}",
      "perUnit": "{{value}} / {{unit}}",
      "costNote": "Değerler hareket anındaki ortalama maliyetle hesaplanır.",
      "onlyMovements": "Stok yalnızca <b>hareket</b> ile değişir. Burada düzenlenebilir miktar alanı yoktur.",
      "itemCard": "Ürün kartı",
      "editInItemCard": "Ürün kartında düzenle →",
      "noMovements": "Bu ürün için henüz hareket yok.",
      "allInLedger": "Tümünü defterde gör →"
    },
    "masked": "gizli",
    "maskedTitle": "Maliyet ve satış fiyatı gizli · operatör rolü",
    "offline": {
      "title": "Bağlantı yok",
      "body": "Gösterilen stok {{time}} itibarıyla. Web’de çevrimdışı kayıt yok — bağlantı gelince yenilenir.",
      "cannotSave": "Bağlantı yok — hareket kaydedilemez."
    },
    "type": {
      "raw_material": "Hammadde",
      "semi_finished": "Yarı mamul",
      "finished_good": "Mamul",
      "packaging": "Ambalaj",
      "consumable": "Sarf"
    },
    "form": {
      "title": "Yeni stok hareketi",
      "draft": "{{no}} · taslak",
      "kind": "Hareket türü",
      "item": "Ürün",
      "itemPlaceholder": "Ürün ara — ad, SKU veya barkod",
      "itemEmpty": "Eşleşen ürün yok.",
      "onHandOption": "{{qty}} eldeki",
      "lot": "Lot / Parti",
      "lotPlaceholder": "Lot seç",
      "lotEmpty": "Bu üründe lot yok.",
      "newLot": "+ Yeni lot · {{no}}",
      "newLotPlain": "+ Yeni lot",
      "newLotLabel": "yeni lot",
      "noLotTracking": "Lot takibi yok",
      "qty": "Miktar",
      "signMinus": "Azalt",
      "signPlus": "Artır",
      "from": "Kaynak lokasyon",
      "to": "Hedef lokasyon",
      "location": "Lokasyon",
      "locationPlaceholder": "Lokasyon seç",
      "locationEmpty": "Eşleşen lokasyon yok.",
      "reason": "Sebep",
      "noManualReason": "Bu tür için elle girilebilen sebep yok.",
      "note": "Not",
      "notePlaceholder": "Kısa not — ör. FBA-US-2026-0035 sevkiyatı için hazırlık",
      "photo": "Foto",
      "removePhoto": "Fotoğrafı kaldır",
      "photoLimit": "En fazla {{count}} fotoğraf eklenebilir.",
      "photoTooBig": "Fotoğraf 10 MB’tan büyük olamaz.",
      "photoUploadFailed": "Hareket kaydedildi ama {{count}} fotoğraf yüklenemedi.",
      "unitCost": "Birim maliyet",
      "unitCostBase": "= {{value}} / {{unit}}",
      "lotSection": "Yeni lot bilgileri",
      "supplier": "Tedarikçi",
      "supplierLotNo": "Tedarikçi lot no",
      "expiry": "Son kullanma",
      "preview": "Sonuç önizleme",
      "previewEmpty": "Ürün, lot, miktar ve lokasyon seçildiğinde sonuç burada görünür.",
      "previewLine": "{{location}} · {{lot}}",
      "totalUnchanged": "Toplam eldeki değişmez",
      "total": "Toplam eldeki",
      "valueImpact": "Değer etkisi",
      "negativeBlocked": "Stok eksiye düşer — {{warehouse}} deposunda eksi stoğa izin yok.",
      "negativeAllowed": "Stok eksiye düşecek — {{warehouse}} deposunda eksi stoğa izin var.",
      "sourceChanged": "Kaynak bakiye değişti: {{before}} → {{after}} {{unit}}",
      "save": "Hareketi kaydet",
      "saveError": "Hareket kaydedilemedi",
      "networkError": "Bağlantı yok — hareket kaydedilemedi. Web’de çevrimdışı kuyruk yok; bağlantı gelince tekrar dene.",
      "noLocations": "Önce depo ve lokasyon tanımla.",
      "noLocationsLink": "Ayarlar › Depolar",
      "dirtyTitle": "Değişiklikler kaydedilmedi",
      "dirtyBody": "Girdiğin bilgiler silinecek.",
      "dirtyConfirm": "Kapat",
      "readOnlyNotice": "Salt okunur — bu rolde değişiklik yapamazsın",
      "errors": {
        "item": "Ürün seç",
        "lot": "Lot seç",
        "from": "Kaynak lokasyon seç",
        "to": "Hedef lokasyon seç",
        "location": "Lokasyon seç",
        "reason": "Sebep seç",
        "sameLocation": "Kaynak ve hedef aynı olamaz",
        "noteRequired": "Bu sebep için not gerekli",
        "noteLong": "Not en fazla 500 karakter olabilir",
        "photoRequired": "Bu sebep için fotoğraf gerekli",
        "insufficient": "Kaynakta yeterli stok yok — en fazla {{max}} {{unit}}"
      },
      "unitCostHintStandard": "Girilmezse ürünün standart maliyeti kullanılır; o da yoksa son giriş maliyeti, hiçbiri yoksa 0 ₺.",
      "unitCostHintAverage": "Girilmezse ürünün mevcut ortalama maliyeti kullanılır.",
      "unitCostNoBasis": "Bu üründe ne standart ne ortalama maliyet var — maliyet girilmezse hareket 0 ₺ ile değerlenir ve stok defteri geri alınmadıkça düzelmez."
    },
    "ledger": {
      "crumb": "Hareket defteri",
      "title": "Hareket defteri",
      "subtitle": "Stok yalnızca hareketle değişir · {{from}}–{{to}} / {{total}} kayıt",
      "subtitleEmpty": "Stok yalnızca hareketle değişir",
      "new": "Yeni hareket",
      "exportName": "aslen-ops-hareket-defteri",
      "exportLimit": "İlk {{count}} kayıt aktarıldı.",
      "preset": {
        "today": "Bugün",
        "yesterday": "Dün",
        "7d": "Son 7 gün",
        "month": "Bu ay",
        "all": "Tüm zamanlar",
        "custom": "Özel aralık…"
      },
      "customFrom": "Başlangıç",
      "customTo": "Bitiş",
      "filter": {
        "kind": "Tür: {{value}}",
        "warehouse": "Depo: {{value}}",
        "person": "Kişi: {{value}}",
        "reason": "Sebep: {{value}}"
      },
      "showReversed": "Geri alınanları göster",
      "clearFilters": "Filtreleri temizle",
      "col": {
        "date": "Tarih",
        "kind": "Tür",
        "item": "Ürün",
        "lot": "Lot",
        "qty": "Miktar",
        "route": "Kaynak → Hedef",
        "reason": "Sebep",
        "who": "Kişi"
      },
      "csv": {
        "no": "No",
        "sku": "SKU",
        "unit": "Birim",
        "from": "Kaynak",
        "to": "Hedef",
        "note": "Not"
      },
      "reversed": "Geri alındı",
      "isReversal": "Ters hareket",
      "emptyToday": "Bugün henüz hareket yok.",
      "emptyWarehouse": "Bu depoda henüz hareket yok.",
      "emptyFiltered": "Bu filtrelerle eşleşen hareket yok.",
      "error": "Hareketler yüklenemedi",
      "moreError": "Daha fazla kayıt yüklenemedi.",
      "loadMore": "Daha fazla yükle",
      "detail": {
        "subtitle": "{{date}} · {{actor}}",
        "item": "Ürün",
        "lot": "Lot / Parti",
        "qty": "Miktar",
        "route": "Kaynak → Hedef",
        "reason": "Sebep",
        "note": "Not",
        "photos": "Fotoğraflar",
        "cost": "Birim maliyet",
        "value": "Değer",
        "source": "Kayıt",
        "sources": {
          "web": "web",
          "mobile": "mobil",
          "import": "içe aktarma",
          "system": "sistem",
          "sync": "senkron"
        },
        "reversedBy": "Geri alan hareket",
        "reversalOf": "Geri aldığı hareket",
        "openItem": "Ürün kartı",
        "photoError": "Fotoğraf açılamadı."
      }
    },
    "route": {
      "receipt": "Mal kabul",
      "production": "Üretim",
      "scrap": "Fire",
      "sale": "Satış",
      "sample": "Numune",
      "return": "İade",
      "opening": "Açılış",
      "count": "Sayım",
      "adjustment": "Düzeltme",
      "issue": "Çıkış"
    },
    "toast": {
      "in": "Giriş kaydedildi · {{qty}} → {{to}}",
      "out": "Çıkış kaydedildi · {{qty}} · {{from}}",
      "transfer": "Transfer kaydedildi · {{qty}} → {{to}}",
      "adjust": "Düzeltme kaydedildi · {{qty}} · {{location}}",
      "undone": "Hareket geri alındı · {{no}}",
      "reversed": "Ters hareket kaydedildi · {{no}}",
      "replay": "Bu hareket zaten kaydedilmişti · {{no}}"
    },
    "reverse": {
      "action": "Ters hareket oluştur",
      "confirmTitle": "Ters hareket",
      "confirmBody": "{{no}} ters çevrilecek: {{qty}}, {{location}}.",
      "confirm": "Ters hareketi kaydet",
      "note": "Not",
      "notePlaceholder": "Neden geri alınıyor?",
      "noteRequired": "Ters kayıt için not gerekli"
    },
    "status": {
      "normal": "normal",
      "low": "düşük",
      "critical": "kritik",
      "negative": "negatif"
    },
    "movementKinds": {
      "in": "Giriş",
      "out": "Çıkış",
      "transfer": "Transfer",
      "adjust": "Düzeltme"
    },
    "reasons": {
      "opening": "Açılış stoğu",
      "count": "Sayım farkı"
    },
    "onHand": "Eldeki",
    "onHandNone": "stok yok",
    "lot": "Lot",
    "lots": {
      "crumb": "Lotlar",
      "title": "Lotlar",
      "subtitle": "{{count}} lot · {{inStock}} stokta",
      "subtitleEmpty": "Henüz lot yok",
      "search": "Lot numarası ara…",
      "filter": {
        "all": "Tümü",
        "inStock": "Stokta",
        "depleted": "Tükendi",
        "quarantine": "Karantina",
        "series": "Tür: {{value}}",
        "supplier": "Tedarikçi: {{value}}"
      },
      "col": {
        "lot": "Lot",
        "item": "Ürün",
        "type": "Tür",
        "location": "Lokasyon",
        "onHand": "Eldeki",
        "received": "Giriş",
        "source": "Kaynak",
        "quality": "Kalite",
        "expiry": "Son kullanma",
        "unitCost": "Birim maliyet",
        "lastMove": "Son hareket"
      },
      "origin": {
        "receipt": "Mal kabul",
        "production": "Üretim",
        "opening": "Açılış stoğu",
        "adjustment": "Elle giriş",
        "return": "İade"
      },
      "qc": {
        "none": "Kayıt yok",
        "pending": "Bekliyor",
        "accepted": "Kabul",
        "passed": "Geçti",
        "failed": "Ret",
        "quarantine": "Karantina"
      },
      "expired": "Süresi geçti",
      "blocked": "Karantina",
      "moreLocations": "+{{count}}",
      "open": "Lot şeceresini aç",
      "empty": "Henüz lot yok. Lotlar mal kabulde, üretimde veya açılış stoğu içe aktarımında oluşur.",
      "importOpening": "Açılış stoğunu içe aktar",
      "emptyFiltered": "Bu filtrelerle eşleşen lot yok.",
      "clearFilters": "Filtreleri temizle",
      "exportName": "aslen-lotlar"
    },
    "counts": {
      "crumb": "Sayımlar",
      "title": "Sayımlar",
      "subtitle": "{{open}} açık oturum · {{pending}} onay bekliyor · son güncelleme {{time}}",
      "subtitleEmpty": "Henüz sayım yok",
      "new": "Yeni sayım",
      "exportName": "sayimlar",
      "wholeWarehouse": "tüm depo",
      "empty": "Henüz sayım yok. Sayımı buradan başlatıp mobilde Sayım ekranından yaparsın.",
      "emptyFiltered": "Bu filtrelerle sayım yok.",
      "clearFilters": "Filtreleri temizle",
      "offlineStart": "Bağlantı yok — sayım başlatılamaz.",
      "filter": {
        "all": "Tümü",
        "open": "Açık",
        "pending": "Onay bekliyor",
        "approved": "Onaylandı"
      },
      "col": {
        "no": "Sayım no",
        "scope": "Depo · lokasyon",
        "status": "Durum",
        "counter": "Sayan",
        "lines": "Satır",
        "variance": "Farklı",
        "value": "Değer etkisi",
        "date": "Tarih"
      },
      "status": {
        "draft": "Taslak",
        "in_progress": "Sayılıyor",
        "submitted": "Onay bekliyor",
        "recount_requested": "Yeniden sayım",
        "approved": "Onaylandı",
        "cancelled": "İptal",
        "reverted": "Geri alındı"
      },
      "kind": {
        "cycle": "sayım",
        "full": "tam sayım",
        "opening": "açılış"
      },
      "line": {
        "equal": "eşit",
        "over": "fark",
        "within": "küçük fark",
        "uncounted": "sayılmadı",
        "conflict": "çakışma",
        "conflictTitle": "Sayım sırasında bu satıra hareket geldi; beklenen miktar yeniden hesaplandı.",
        "recount": "yeniden sayım",
        "adjusted": "düzeltildi",
        "ignored": "yok sayıldı",
        "unexpected": "beklenmeyen"
      },
      "start": {
        "title": "Sayım başlat",
        "subtitle": "Sayım mobilde yapılır; web’den oturum açıp atayabilirsin.",
        "warehouse": "Depo",
        "warehousePlaceholder": "Depo seç",
        "warehouseRequired": "Depo seç.",
        "locations": "Lokasyonlar",
        "locationsHint": "Bu depoda {{count}} lokasyon sayılabilir.",
        "locationsRequired": "En az bir lokasyon seç.",
        "selectAll": "Tümünü seç",
        "clearAll": "Seçimi temizle",
        "remove": "{{code}} seçimini kaldır",
        "zone": "{{zone}} · {{count}} lokasyon",
        "searchLocations": "Lokasyon ara…",
        "noMatch": "Bu aramayla lokasyon yok.",
        "pickWarehouseFirst": "Önce depo seç.",
        "noLocations": "Bu depoda aktif lokasyon yok. Ayarlar › Depolar / lokasyonlar’dan ekle.",
        "defaultLocation": "Genel",
        "assignee": "Sayacak kişi",
        "assigneeHint": "Boş bırakırsan sayımı mobilde açan kişi alır.",
        "assigneeNone": "Atama yok",
        "blind": "Kör sayım",
        "blindNote": "beklenen miktarlar sayan kişiye gösterilmez",
        "note": "Not",
        "submit": "Sayımı başlat",
        "started": "{{countNo}} başlatıldı · {{name}} bildirildi",
        "startedUnassigned": "{{countNo}} başlatıldı",
        "replay": "{{countNo}} zaten başlatılmıştı",
        "mobileNote": "Sayım girişi yalnızca mobilde yapılır. Oturum mobil Sayım ekranında görünür; onayı web’de verirsin."
      },
      "review": {
        "title": "Sayım incelemesi",
        "subtitle": "Onaylandığında her fark için bir düzeltme hareketi oluşur",
        "backToList": "Sayımlara dön",
        "notFound": "Bu sayım bulunamadı.",
        "noLines": "Bu sayımda satır yok.",
        "exportName": "sayim-{{countNo}}",
        "selectAll": "Tüm farklı satırları seç",
        "selectLine": "{{name}} satırını seç",
        "col": {
          "item": "Ürün · lot",
          "location": "Lokasyon",
          "expected": "Beklenen",
          "counted": "Sayılan",
          "variance": "Fark",
          "value": "Değer etkisi"
        },
        "tile": {
          "counted": "Sayılan satır",
          "countedUnit": "/ {{count}} beklenen",
          "variance": "Farklı satır",
          "varianceUnit": "satır",
          "net": "Net miktar farkı",
          "value": "Değer etkisi"
        },
        "caseEquivalent": "koli eşdeğeri",
        "mixedUnit": "karışık birim",
        "netExcluded": "Koli birimi olmayan {{count}} satır dahil değil",
        "recount": "Yeniden saydır",
        "approve": "Farkları onayla",
        "pickRows": "Onaylanacak satır seç",
        "offlineBody": "Onay ve yeniden sayım için bağlantı gerekiyor.",
        "selfApproval": "Kendi sayımını ortağın onaylar",
        "selfApprovalOwner": "Kendi sayımını onaylamak için Ayarlar › Stok ve sayım’dan “Kendi sayımını onaylama”yı aç.",
        "mobileOnly": "Sayım girişi mobilde yapılır — web’de oturum açılır, incelenir ve onaylanır.",
        "conflictTitle": "{{count}} satırda sayım sırasında hareket oldu",
        "conflictBody": "Bu satırların beklenen miktarı sayım anına göre yeniden hesaplandı. Kontrol edip onayla.",
        "footerSelected": "{{selected}} satır seçildi · {{counted}} satır sayıldı",
        "footerNet": "net {{value}}",
        "banner": {
          "submitted": "{{counter}} sayımı onayını bekliyor",
          "submittedNoName": "Sayım onayını bekliyor",
          "counted": "{{counted}} satır sayıldı, {{over}} satırda fark var",
          "countedClean": "{{counted}} satır sayıldı, fark yok",
          "running": "Sayım sürüyor",
          "progress": "{{counted}} / {{expected}} satır sayıldı",
          "recount": "Yeniden sayım istendi",
          "recountBody": "{{count}} satır {{name}} tarafından yeniden sayılacak",
          "approved": "Sayım onaylandı",
          "approvedBy": "{{name}} onayladı",
          "movements": "{{count}} düzeltme hareketi",
          "seeMovements": "Hareketleri gör",
          "cancelled": "Sayım iptal edildi",
          "reverted": "Sayım geri alındı"
        }
      },
      "approve": {
        "title": "Sayım farklarını onayla",
        "lead": "Bu işlem geri alınamaz. Onayladığında aşağıdaki",
        "leadCount": "{{count}} düzeltme hareketi",
        "leadTail": "oluşur ve stok kalıcı olarak değişir.",
        "stale": "Sayım bu arada güncellendi — sayılar yenilendi.",
        "staleRefused": "Sayım bu arada değişti — sayılar yenilendi",
        "staleSame": "Sayım bu arada değişti — gösterilen sayılar aynı",
        "staleCheck": "Sayıları kontrol edip yeniden onayla.",
        "changedLines": "{{count}} satırın sayımı değişti",
        "droppedLines": "{{count}} satır seçimden çıktı",
        "appearedLines": "{{count}} yeni fark eklendi, seçilmedi",
        "nothingLeft": "Onaylanacak satır kalmadı — sayım listesine dönüp yeniden bak.",
        "noLot": "düzeltme",
        "total": "Toplam değer etkisi",
        "unselected": "{{count}} farklı satır seçilmedi; bu satırlarda stok değişmeyecek.",
        "uncounted": "{{count}} sayılmayan satır yok sayılacak.",
        "reason": "Sebep olarak “Sayım farkı” işaretlenecek ve oturuma bağlanacak",
        "cta": "{{count}} hareketi oluştur",
        "done": "{{count}} düzeltme hareketi oluşturuldu"
      },
      "close": {
        "title": "Sayımı kapat",
        "body": "{{count}} satır sayıldı ve fark yok. Sayımı kapattığında stok değişmez; oturum onaylanmış olarak kapanır.",
        "cta": "Sayımı kapat"
      },
      "recount": {
        "title": "Yeniden sayım iste",
        "body": "Seçili {{count}} satır {{name}} tarafından yeniden sayılacak. Sayım onaylanana kadar stok değişmez.",
        "bodyUnassigned": "Seçili {{count}} satır yeniden sayılacak. Sayım onaylanana kadar stok değişmez.",
        "note": "Not",
        "notePlaceholder": "Örn. D1-B-04 rafının arkasına da bak",
        "cta": "Yeniden saydır",
        "done": "Yeniden sayım istendi · {{count}} satır"
      }
    },
    "location": "Lokasyon",
    "locations": "Lokasyonlar",
    "warehouse": "Depo",
    "zone": "Bölge",
    "qty": "Miktar",
    "unit": "Birim",
    "baseUnit": "Temel birim",
    "stockUnit": "Stok birimi",
    "movesOnlyByMovement": "Stok yalnızca hareket ile değişir.",
    "fbaFromAmazon": "FBA stoğu Amazon bağlantısıyla gelir.",
    "locationTypes": {
      "storage": "Depolama",
      "receiving": "Mal kabul",
      "shipping": "Sevkiyat",
      "production": "Üretim hattı",
      "quarantine": "Karantina",
      "scrap": "Fire",
      "transit": "Yolda"
    },
    "warehouseTypes": {
      "own": "Kendi depo",
      "fba": "FBA deposu",
      "supplier": "Tedarikçi deposu",
      "transit": "Yolda (transit)",
      "third_party": "Üçüncü taraf depo"
    },
    "trace": {
      "title": "Lot şeceresi",
      "subtitleFull": "Bobin lotundan FBA sevkiyatına kadar tam zincir · {{count}} kademe",
      "subtitleChain": "{{from}} → {{to}} · tam zincir · {{count}} kademe",
      "subtitleSingle": "Bu lot henüz başka bir kayda bağlanmadı · 1 kademe",
      "forward": "İleriye izle",
      "backward": "Geriye izle",
      "graphLabel": "Lot şeceresi",
      "tierAria": "{{n}}. kademe · {{label}}",
      "tier": {
        "source": "Kaynak",
        "lot": "Lot",
        "output": "Çıktı",
        "bobbin": "Bobin lotu",
        "napkin": "Peçete lotu",
        "productionOrder": "Üretim emri",
        "fbaShipment": "FBA sevkiyat",
        "sale": "Satış",
        "waste": "Fire",
        "sample": "Numune"
      },
      "badge": {
        "origin": "kaynak",
        "scrap": "fire",
        "sale": "satıldı",
        "fba_inbound": "yolda",
        "sample": "numune",
        "production_consume": "üretim",
        "production_order": "devam"
      },
      "nodeAria": "{{tier}} {{code}}, {{qty}}, {{status}}",
      "placeholder": "Bu lot henüz bir üretimde, sevkiyatta veya satışta kullanılmadı.",
      "legendSelected": "Seçili düğüm",
      "legendInChain": "Zincirde",
      "massBalance": "Toplam kütle dengesi:",
      "massBalanceValue": "{{in}} kg giriş → {{out}} kg mamul + {{waste}} kg fire",
      "massBalanceGap": "{{gap}} kg açıklanamayan fark",
      "massBalanceRunning": "üretim sürüyor",
      "truncated": "Zincir kısaltıldı — {{count}} düğüm gösterilmiyor.",
      "panelLabel": "Seçili düğüm ayrıntıları",
      "qty": "Miktar",
      "unitCost": "Birim maliyet",
      "onHandNote": "Eldeki: {{qty}}",
      "costBreakdown": "Maliyet kırılımı",
      "costEmpty": "Maliyet henüz hesaplanmadı.",
      "qcTitle": "Kalite kontrol",
      "qcEmpty": "Bu lot için kalite kaydı yok.",
      "specs": "Künye",
      "spec": {
        "supplier": "Tedarikçi",
        "supplierLot": "Tedarikçi lot no",
        "purchaseOrder": "Satın alma siparişi",
        "receipt": "Mal kabul",
        "productionOrder": "Üretim emri",
        "producedAt": "Üretim tarihi",
        "location": "Lokasyon",
        "container": "Konteyner",
        "expiry": "Son kullanma",
        "origin": "Kaynak",
        "note": "Not",
        "initial": "Giriş miktarı"
      },
      "movementsTitle": "Hareketler",
      "movements": "Hareketleri gör",
      "printLabel": "Etiket yazdır",
      "printLabelLater": "Etiket ekranı Faz 2’nin devamında geliyor.",
      "labelOnlyLots": "Etiket yalnızca lotlar için yazdırılır.",
      "notFound": "Bu lot bulunamadı. Silinmiş veya numarası değişmiş olabilir.",
      "backToLots": "Lotlara dön",
      "exportName": "aslen-lot-seceresi",
      "exported": "Şecere dışa aktarıldı",
      "csv": {
        "tier": "Kademe",
        "kind": "Tür",
        "code": "Numara",
        "item": "Ürün",
        "target": "Lokasyon / hedef",
        "from": "Kaynak",
        "to": "Hedef"
      },
      "status": {
        "accepted": "Kabul",
        "passed": "Geçti",
        "pending": "Bekliyor",
        "failed": "Ret",
        "quarantine": "Karantina",
        "inStock": "Stokta",
        "depleted": "Tükendi",
        "negative": "Negatif",
        "inChain": "Zincirde"
      },
      "cost": {
        "fob_unit": "FOB birim fiyat",
        "landed_addon": "Yüklü ek maliyet",
        "landed_unit": "Yüklü birim ($)",
        "fx": "Kur ({{date}})",
        "landed_unit_base": "Yüklü birim (₺)",
        "opening_unit": "Açılış birim maliyeti",
        "material": "Malzeme",
        "packaging": "Ambalaj",
        "labour": "İşçilik + makine",
        "overhead": "Genel gider",
        "total": "Toplam gerçek"
      }
    },
    "lotEdit": {
      "edit": "Lotu düzenle",
      "title": "Lot bilgilerini düzenle",
      "subtitle": "{{lot}} · miktar yalnızca hareketle değişir",
      "expiry": "Son kullanma tarihi",
      "expiryHint": "Boş bırakılırsa raf ömrü takip edilmez.",
      "supplierLot": "Tedarikçi lot numarası",
      "supplierLotHint": "Tedarikçinin sevk ettiği partiye verdiği numara.",
      "qtyNote": "Lot miktarı buradan değişmez — miktar yalnızca stok hareketiyle değişir.",
      "expiryInvalid": "Geçerli bir tarih seç.",
      "expiryBeforeReceipt": "Son kullanma tarihi mal kabul tarihinden önce olamaz.",
      "nothingToSave": "Değişiklik yok.",
      "saved": "{{lot}} güncellendi",
      "block": "Karantinaya al",
      "unblock": "Karantinadan çıkar",
      "blockTitle": "Lot karantinaya alınsın mı?",
      "blockBody": "{{lot}} karantinaya alındığında bu lottan çıkış hareketi yapılamaz. Eldeki {{qty}} stokta kalır ama kullanılamaz.",
      "unblockTitle": "Lot karantinadan çıkarılsın mı?",
      "unblockBody": "{{lot}} yeniden kullanılabilir olur — eldeki {{qty}} çıkış hareketlerine açılır.",
      "blocked": "{{lot}} karantinaya alındı",
      "unblocked": "{{lot}} karantinadan çıkarıldı",
      "onlyApprover": "Karantina kararını yalnızca sen ve ortağın verebilir."
    }
  },
  "items": {
    "title": "Ürünler",
    "searchPlaceholder": "Ürün, SKU, ASIN ara…",
    "countLine": "{{count}} ürün · {{filter}}",
    "allTypes": "tüm tipler",
    "attrFilterCount": "{{count}} nitelik filtresi",
    "import": "İçe aktar",
    "columns": "Sütunlar",
    "new": "Yeni ürün",
    "masked": "gizli",
    "types": {
      "all": "Tümü",
      "raw_material": "hammadde",
      "semi_finished": "yarı mamul",
      "finished_good": "mamul",
      "packaging": "ambalaj",
      "consumable": "sarf",
      "service": "hizmet"
    },
    "typesTitle": {
      "raw_material": "Hammadde",
      "semi_finished": "Yarı mamul",
      "finished_good": "Mamul",
      "packaging": "Ambalaj",
      "consumable": "Sarf",
      "service": "Hizmet"
    },
    "status": {
      "draft": "taslak",
      "active": "aktif",
      "inactive": "pasif"
    },
    "stockStatus": {
      "low": "Düşük",
      "critical": "Kritik",
      "negative": "Negatif"
    },
    "attrs": {
      "size": "Ebat",
      "fold": "Kat",
      "format": "Format",
      "colour": "Renk",
      "print": "Baskı",
      "printDesign": "Baskı deseni",
      "gsm": "Gramaj",
      "unitWeight": "Peçete ağırlığı",
      "rollWidth": "Genişlik",
      "dims": "Ölçüler",
      "widthMm": "Genişlik",
      "material": "Malzeme",
      "cert": "Sertifika",
      "hs": "GTİP",
      "origin": "Menşe"
    },
    "folds": {
      "1/4": "1/4 kat",
      "1/6": "1/6 kat",
      "1/8": "1/8 kat",
      "pocket": "Cep",
      "flat": "Düz"
    },
    "formats": {
      "dinner": "Yemek",
      "cocktail": "Kokteyl",
      "guest_towel": "El havlusu"
    },
    "prints": {
      "none": "yok",
      "foil": "Varak",
      "digital": "Dijital",
      "foil_digital": "Varak + dijital"
    },
    "colours": {
      "beyaz": "Beyaz",
      "fildisi": "Fildişi",
      "bej": "Bej",
      "gri": "Gri",
      "altin": "Altın",
      "lacivert": "Lacivert",
      "siyah": "Siyah",
      "terracotta": "Terracotta",
      "kahve": "Kahve",
      "bebek_mavisi": "Bebek mavisi"
    },
    "filters": {
      "add": "+ {{key}}",
      "clear": "Filtreleri temizle",
      "active": "{{key}}: {{value}}",
      "remove": "{{key}} filtresini kaldır"
    },
    "views": {
      "heading": "Kayıtlı görünümler",
      "all": "Tüm ürünler",
      "critical": "Kritik izleme",
      "on_amazon": "Amazon’da satılan",
      "unmapped": "Eşleşmesi olmayan",
      "inactive": "Pasif ürünler",
      "groups": "Ürün grupları"
    },
    "cols": {
      "product": "Ürün",
      "type": "Tip",
      "sizeFold": "Ebat · kat",
      "colour": "Renk",
      "onHand": "Eldeki",
      "stdCost": "Std. maliyet",
      "amazon": "Amazon",
      "status": "Durum"
    },
    "chooser": {
      "title": "Sütunlar",
      "reset": "Sıfırla",
      "name": "Ürün adı",
      "sku": "SKU",
      "type": "Tip",
      "sizeFold": "Ebat · kat",
      "colour": "Renk",
      "onHand": "Eldeki",
      "stdCost": "Standart maliyet",
      "marketplaces": "Amazon pazar yerleri",
      "cover": "Karşılama günü",
      "reorderPoint": "Yeniden sipariş noktası",
      "lastMove": "Son hareket"
    },
    "bulk": {
      "selected": "ürün seçildi",
      "labels": "Etiket yazdır",
      "assignAttr": "Nitelik ata",
      "addToView": "Kayıtlı görünüme ekle",
      "export": "Dışa aktar",
      "deactivate": "Pasife al",
      "clear": "Seçimi temizle",
      "hiddenByFilter": "{{count}} filtre dışında",
      "selectAll": "Görünen ürünleri seç",
      "labelsPending": "Etiket ekranı bu fazın ilerleyen turunda açılacak"
    },
    "empty": {
      "title": "Henüz ürün yok",
      "body": "İlk ürününü ekle ya da hazır şablonla topluca içe aktar.",
      "noResult": "‘{{q}}’ ile eşleşen ürün yok.",
      "noResultAction": "Aramayı temizle",
      "noFilterResult": "Bu filtrelerle eşleşen ürün yok.",
      "groups": "Henüz ürün grubu yok. Varyantları bir arada tutmak için grup tanımla.",
      "boms": "Bu ürünün ağacı yok. Bileşenleri ve operasyonları tanımlamak için taslak oluştur.",
      "uoms": "Bu üründe yalnızca temel birim var.",
      "whereUsed": "Bu ürün hiçbir ürün ağacında kullanılmıyor.",
      "critical": "Kritik seviyede ürün yok — hepsi yeniden sipariş noktasının üstünde.",
      "unmapped": "Tüm aktif mamuller en az bir Amazon listesine eşleşmiş."
    },
    "confirm": {
      "deactivateTitle": "Ürünler pasife alınsın mı?",
      "deactivateBody": "{{count}} ürün pasif olacak; listelerden ve seçicilerden çıkar. Geçmiş hareketler ve maliyetler olduğu gibi kalır.",
      "deactivate": "Pasife al",
      "deleteDraftTitle": "Taslak silinsin mi?",
      "deleteDraftBody": "v{{version}} taslağı ve içindeki bileşenler silinecek. Yürürlükteki sürüm etkilenmez.",
      "deleteDraft": "Taslağı sil",
      "activateTitle": "v{{version}} yürürlüğe alınsın mı?",
      "activateBody": "Yeni sürüm hemen geçerli olur, önceki sürüm arşivlenir. Standart maliyet bu ağaçtan yeniden hesaplanır.",
      "activate": "Yürürlüğe al",
      "deleteGroupTitle": "Grup silinsin mi?",
      "deleteGroupBody": "‘{{name}}’ grubu silinecek. Gruptaki ürünler grupsuz kalır.",
      "deactivateSkipped": "{{count}} ürün yürürlükteki bir ürün ağacında bileşen; sunucu bunları atlayabilir: {{skus}}"
    },
    "toast": {
      "saved": "Ürün kaydedildi",
      "statusChanged": "{{count}} ürün güncellendi",
      "statusPartial": "{{ok}} ürün güncellendi, {{failed}} tanesi yapılamadı",
      "attributesAssigned": "{{count}} ürüne nitelik atandı",
      "barcodeSaved": "Barkod kaydedildi",
      "groupSaved": "Grup kaydedildi",
      "bomSaved": "Ürün ağacı kaydedildi",
      "bomActivated": "v{{version}} yürürlüğe alındı",
      "bomCopied": "Ürün ağacı kopyalandı — taslak olarak açıldı",
      "bomDraftDeleted": "Taslak silindi",
      "costRecomputed": "Standart maliyet yeniden hesaplandı",
      "created": "Ürün oluşturuldu — {{sku}}"
    },
    "form": {
      "newTitle": "Yeni ürün",
      "editTitle": "Ürünü düzenle",
      "copyTitle": "Ürünü kopyala",
      "sections": {
        "general": "Kimlik",
        "attributes": "Nitelikler",
        "units": "Birimler ve paketleme",
        "planning": "Planlama",
        "customs": "Gümrük",
        "cost": "Maliyet"
      },
      "sku": "SKU",
      "skuHint": "Büyük harf, rakam, nokta, alt çizgi ve tire. Hareket gördükten sonra değiştirmemeye çalış.",
      "skuSuggest": "Nitelikten öner",
      "nameTr": "Ad",
      "nameEn": "Ad (İngilizce)",
      "shortName": "Kısa ad",
      "shortNameHint": "Etiket ve mobil listelerde kullanılır.",
      "type": "Tip",
      "group": "Ürün grubu",
      "groupNone": "Grupsuz",
      "status": "Durum",
      "baseUnit": "Temel birim",
      "baseUnitHint": "Stok bu birimde saklanır ve sonradan değiştirilemez.",
      "stockUnit": "Stok birimi",
      "stockUnitHint": "Ekranlarda eldeki stok bu birimle gösterilir.",
      "barcode": "Barkod",
      "uomPreset": "Birim hazırı",
      "uomPresetNapkin": "Peçete (adet · paket · koli · kg)",
      "uomPresetBobbin": "Bobin (kg · bobin · palet)",
      "uomPresetNone": "Elle tanımla",
      "uomUnit": "Birim",
      "uomFactor": "Temel birime çarpan",
      "uomBarcode": "Barkod",
      "uomPurchaseDefault": "Satın alma varsayılanı",
      "uomSalesDefault": "Satış varsayılanı",
      "uomOrderMultiple": "Sipariş katı",
      "uomCountable": "Sayımda kullanılır",
      "addUom": "+ Birim ekle",
      "lotTracked": "Lot izlenir",
      "lotTrackedHint": "Kapalıyken hareketler lotsuz yazılır.",
      "lotSeries": "Lot serisi",
      "shelfLife": "Raf ömrü (gün)",
      "reorderPoint": "Yeniden sipariş noktası",
      "reorderQty": "Sipariş miktarı",
      "safetyStockDays": "Güvenlik stoğu (gün)",
      "leadTimeDays": "Tedarik süresi (gün)",
      "minBatchQty": "Minimum parti",
      "defaultSupplier": "Varsayılan tedarikçi",
      "hsCode": "GTİP",
      "countryOfOrigin": "Menşe ülke",
      "notes": "Not",
      "standardCost": "Standart maliyet",
      "standardCostHint": "Satın alınan ürünlerde tedarikçi para biriminde gir; ₺ karşılığı kurdan hesaplanır.",
      "standardCostComputed": "{{rate}} kurundan {{value}}",
      "weightFormulaHint": "formül: {{value}}",
      "sizeWidth": "En (cm)",
      "sizeHeight": "Boy (cm)",
      "uomPresetNapkinShort": "Peçete",
      "uomPresetBobbinShort": "Bobin",
      "certHint": "Birden fazlaysa aralarına · ya da virgül koy.",
      "costFromBom": "Standart maliyet ürün ağacından hesaplanır; burada elle girilmez.",
      "standardCostRate": "Kur (₺)",
      "unsavedTitle": "Değişiklikler kaydedilmedi",
      "unsavedBody": "Çıkarsan girdiğin bilgiler kaybolur.",
      "unsavedLeave": "Çık",
      "packQty": "Paket içi (adet)",
      "casePacks": "Koli içi (paket)",
      "palletCases": "Palet (koli)",
      "packagingHint": "Ayarlardaki varsayılan geliyor; bu ürün farklı paketleniyorsa değiştir.",
      "copySourceHint": "{{sku}} ürününden kopyalanıyor — yeni bir SKU ver.",
      "costMasked": "Maliyet alanlarını yalnızca ortaklar görebilir."
    },
    "groups": {
      "title": "Ürün grupları",
      "new": "Grup ekle",
      "edit": "Grubu düzenle",
      "name": "Ad",
      "description": "Açıklama",
      "variantKeys": "Varyant nitelikleri",
      "variantKeysHint": "Aynı gruptaki ürünlerin yalnızca bu nitelikleri farklıdır — ürün ağacı kopyalarken renk ataması buradan türer.",
      "lotSeries": "Lot serisi",
      "itemCount": "{{count}} ürün"
    },
    "detail": {
      "tabs": {
        "general": "Genel",
        "stock": "Stok",
        "bom": "Ürün ağacı",
        "cost": "Maliyet",
        "amazon": "Amazon eşleşmeleri",
        "suppliers": "Tedarikçiler",
        "movements": "Hareketler",
        "documents": "Belgeler",
        "pricing": "Satış fiyatı"
      },
      "photo": "ürün\nfotoğrafı",
      "stats": {
        "onHand": "Eldeki",
        "stdCost": "Std. maliyet",
        "marketplaces": "Pazar yeri",
        "reorderPoint": "Sipariş noktası"
      },
      "general": {
        "attributes": "Nitelikler",
        "planning": "Planlama ve paketleme",
        "salesPack": "Satış paketi",
        "case": "Koli",
        "caseDims": "Koli ölçüsü",
        "pallet": "Palet",
        "reorderPoint": "Yeniden sipariş noktası",
        "safetyStock": "Güvenlik stoğu",
        "batch": "Üretim partisi",
        "leadTime": "Üretim süresi",
        "shelfLife": "Raf ömrü",
        "unlimited": "sınırsız",
        "lotTracked": "lot izlenir",
        "lotNotTracked": "lot izlenmez",
        "days": "{{count}} gün",
        "minQty": "min. {{qty}}"
      },
      "stock": {
        "byLocation": "Lokasyon bazında eldeki",
        "total": "Toplam",
        "lots": "Lotlar",
        "lot": "Lot",
        "location": "Lokasyon",
        "source": "Kaynak",
        "qty": "Miktar",
        "onlyMovements": "Stok yalnızca <b>hareket</b> ile değişir — bu sekmede düzenlenebilir alan yoktur.",
        "emptyLocations": "Bu üründe henüz stok yok. İlk hareketi girdiğinde lokasyonlar burada listelenir.",
        "emptyLots": "Eldeki lot yok.",
        "notLotTracked": "Bu ürün lot takibi yapmıyor."
      },
      "bom": {
        "title": "Ürün ağacı",
        "forQty": "{{date}} · {{qty}} için",
        "addComponent": "+ Bileşen ekle",
        "addOperation": "+ Operasyon ekle",
        "component": "Bileşen",
        "qtyPer": "Miktar",
        "scrap": "fire {{pct}}",
        "scrapPct": "Fire %",
        "optional": "Opsiyonel",
        "ops": "Operasyonlar",
        "opSeq": "#",
        "opName": "Operasyon",
        "opWorkCenter": "İş merkezi",
        "opMinutes": "dk/1000",
        "opScrap": "Fire %",
        "totalTime": "Toplam süre",
        "totalTimeValue": "{{min}} dk/1000 adet",
        "history": "Sürüm geçmişi",
        "newVersion": "Yeni sürüm",
        "copyFrom": "Başka üründen kopyala",
        "swapVariants": "Bileşenleri bu ürünün rengine çevir",
        "changeNote": "Değişiklik notu",
        "costTitle": "{{qty}} malzeme maliyeti",
        "costSub": "Bu sürümdeki miktarlarla",
        "scrapMismatch": "Bileşen firesi operasyon firelerinin toplamından farklı.",
        "status": {
          "draft": "taslak",
          "active": "yürürlükte",
          "archived": "arşiv"
        },
        "event": {
          "draft": "v{{v}} taslak oluşturuldu",
          "active": "v{{v}} yürürlüğe alındı",
          "archived": "v{{v}} arşivlendi"
        },
        "version": "Sürüm",
        "linesEmpty": "Bu sürümde bileşen yok.",
        "opsEmpty": "Operasyon eklenmedi — maliyette işçilik ve makine sıfır sayılır.",
        "grossHint": "Fire dahil {{qty}}",
        "missingCost": "{{count}} bileşenin standart maliyeti yok",
        "readOnlyNote": "Ürün ağacı bu turda salt okunur; taslak düzenleyici bir sonraki turda açılacak.",
        "serviceEmpty": "Hizmet ürünlerinin ürün ağacı olmaz.",
        "whereUsed": "Kullanıldığı ürün ağaçları",
        "qtyPerBase": "Miktar / temel parti"
      },
      "cost": {
        "standard": "Standart maliyet",
        "actual": "Gerçek maliyet (son emir)",
        "average": "Ortalama maliyet",
        "breakdownActual": "Kırılım — gerçek maliyet",
        "breakdownStandard": "Kırılım — standart maliyet",
        "trend": "Standart maliyet trendi",
        "trendSub": "Son 12 ay · {{unit}}",
        "change12": "12 ayda değişim",
        "recompute": "Yeniden hesapla",
        "driftWarning": "Ürün ağacından hesaplanan maliyet kayıtlı standart maliyetten %{{pct}} sapıyor.",
        "cats": {
          "material": "Malzeme — {{what}}",
          "packaging": "Ambalaj — {{what}}",
          "labour": "İşçilik",
          "machine": "Makine",
          "consumable": "Varak / mürekkep",
          "overhead": "Genel gider %{{pct}}",
          "materialShort": "Malzeme",
          "packagingShort": "Ambalaj",
          "overheadMissing": "Genel gider (oran girilmedi)"
        },
        "standardBomNote": "v{{v}} ürün ağacı · {{date}}",
        "standardManualNote": "elle girildi · {{date}}",
        "standardEmpty": "Henüz standart maliyet yok.",
        "actualPending": "İlk üretim emri tamamlanınca hesaplanır.",
        "averageNote": "eldeki {{qty}} {{unit}} · ağırlıklı ortalama",
        "averageEmpty": "Eldeki stok yok.",
        "breakdownEmpty": "Kırılım için standart maliyetin hesaplanmış olması gerekiyor.",
        "trendEmpty": "Trend için en az iki ay veri gerekiyor.",
        "driftTitle": "Ürün ağacına göre standart maliyet değişti",
        "driftBody": "Ağaçtan hesaplanan: {{computed}} · kayıtlı: {{stored}} ({{pct}})."
      },
      "pricing": {
        "noMigrationTitle": "Kanal tanımları henüz veritabanında yok",
        "noMigrationBody": "Hesap, uygulamanın içindeki Trendyol varsayılanlarıyla çalışıyor; sonuç doğru ama kaydedilemiyor. Göç (20261104000001) uygulandığında komisyon, kargo ve hedef marj ilan olarak saklanır.",
        "noCostTitle": "Bu ürünün birim maliyeti bilinmiyor",
        "noCostBody": "Fiyat, maliyet olmadan yalnızca komisyonu karşılar. Maliyet sekmesinden standart maliyeti gir ya da alış faturasını mal kabul ederek gerçek maliyeti oluştur.",
        "channel": "Pazaryeri",
        "packQty": "İlan paketi",
        "packQtyHint": "Bir ilanda satılan adet",
        "mode": "Hesap yönü",
        "modePrice": "Fiyatı hesapla",
        "modeMargin": "Elimdeki fiyatı denetle",
        "targetMargin": "Hedef marj",
        "listPrice": "Liste fiyatı",
        "savedListing": "Kayıtlı ilan",
        "createListing": "İlan olarak kaydet",
        "saved": "İlan kaydedildi",
        "saveNeedsMigration": "Kaydetmek için göçün uygulanması gerekiyor.",
        "unreachableTitle": "Bu marj hiçbir fiyatla tutmaz",
        "unreachableBody": "Komisyon ve reklam, satışın %{{pct}}'ini daha baştan alıyor; hedef marjla toplamı %100'ü aşıyor. Marjı düşür ya da komisyonu/reklamı azalt.",
        "awaitingPriceTitle": "Denetlenecek fiyatı gir",
        "awaitingPriceBody": "Liste fiyatını yazınca marj, başabaş ve hakediş bu fiyata göre hesaplanır. Aşağıdaki tablo fiyat girilmeden de paket adedine göre çalışır.",
        "requiredPrice": "Satışa sunulacak fiyat",
        "requiredPriceNote": "KDV dahil · {{per}}/{{unit}}",
        "afterDiscount": "Panele yazılacak · alıcı {{pct}} indirimle {{paid}} öder",
        "corporateTax": "Kurumlar vergisi",
        "netProfit": "Vergi sonrası net kâr",
        "margin": "Katkı marjı",
        "marginNote": "{{profit}} katkı · maliyet üzerine {{markup}}",
        "breakEven": "Başabaş fiyat",
        "breakEvenNote": "Bu fiyatın altında zarar",
        "payout": "Pazaryerinden yatan",
        "payoutNote": "{{days}} gün sonra · komisyon, kargo ve stopaj düşülmüş",
        "stack": "Maliyet yığını",
        "stackSub": "KDV hariç · bir ilan başına",
        "stackEmpty": "Girilmiş maliyet yok.",
        "netRevenue": "Hasılat (KDV hariç)",
        "totalCost": "Toplam maliyet",
        "profit": "Katkı payı",
        "scales": "fiyatla büyür",
        "packUnits": "× {{n}} kutu",
        "desiBadge": "{{desi}} desi",
        "ephBadge": "+ {{amount}} EPH",
        "ladderPackWarn": "Ambalaj her satırda sabit tutuluyor — bir kutunun kaç adet aldığı girilmedi. Girilirse büyük paketler gerçek kutu sayısıyla hesaplanır.",
        "ladderShipWarn": "Kargo her satırda sabit tutuluyor, oysa desi paketle büyür: 100 adet ≈ 880 g, 600 adet ≈ 5,3 kg. Büyük paketlerin gerçek kargosu buradakinden yüksek — desi tarifesi girilene kadar merdiven büyük paket lehine eğiliyor.",
        "notional": "itibari",
        "cash": "Nakit ve vergi",
        "grossPrice": "Alıcının ödediği",
        "vatOut": "Hesaplanan KDV",
        "vatIn": "İndirilecek KDV",
        "vatPayable": "Bu satışın KDV borcu",
        "vatCarry": "devreden KDV'yi besler",
        "withholding": "E-ticaret stopajı",
        "withholdingNote": "gider değil, kurumlar vergisinden mahsup",
        "cashAfterVat": "KDV ödendikten sonra kalan",
        "cashFoot": "Stopaj (9284 s. C.B. Kararı, %1) KDV hariç satış bedeli üzerinden kesilir ve yıllık kurumlar vergisinden mahsup edilir; bu yüzden maliyet yığınında yoktur. Kâr marjı düşük kaldığı sürece mahsup edilemeyen kısım iade alacağına dönüşür.",
        "params": "Parametreler",
        "paramsSub": "\"Varsayım\" etiketli olanlar satıcı panelinden doğrulanmalı",
        "assumed": "Varsayım",
        "ladder": "Paket adedi fiyatı nasıl değiştiriyor",
        "ladderSub": "Kargo ve hizmet bedeli gönderi başına; paket büyüdükçe adet başına payı düşer",
        "ladderFoot": "Her satır aynı hedef marjla yeniden çözülür — paket adetlerini tek bir fiyatta karşılaştırmak anlamlı bir soru değil. Yönü \"{{mode}}\" seçmiş olsan da bu tablo fiyatı hesaplar.",
        "costSource": {
          "average": "Birim maliyet {{cost}}/{{unit}} — hareketli ortalama (gerçekleşen alışlardan)",
          "standard": "Birim maliyet {{cost}}/{{unit}} — standart maliyet. Elhadefler proformasından gelen referans rakam Aslen'in gerçek maliyeti değil (E25); alış faturası girilince bu satır ortalamaya döner."
        },
        "lines": {
          "goods": "Mal maliyeti",
          "packaging": "Ambalaj (koli, poşet, etiket)",
          "labour": "Paketleme işçiliği",
          "other": "Diğer (e-arşiv, entegratör)",
          "overhead": "Genel gider payı",
          "commission": "Pazaryeri komisyonu",
          "serviceFee": "Hizmet bedeli",
          "shipping": "Kargo",
          "ads": "Reklam",
          "returns": "İade yükü",
          "finance": "Vade maliyeti"
        },
        "p": {
          "commission": "Komisyon",
          "shipping": "Kargo",
          "desi": "Desi",
          "desiHint": "Bu paketin desisi; paket adedi değişince orantılı ölçeklenir",
          "desiUnit": "desi",
          "shippingFromTariff": "{{desi}} desi · taşıyıcı tarifesinden okunuyor",
          "eph": "EPH katkı payı",
          "ephHint": "Evrensel posta hizmeti payı %2 (6475 s.K. m.15) + BTK idari ücreti %0,35 — taşıyıcının KDV hariç bedeli üzerinden",
          "shippingEphIncl": "Kargo fiyatı EPH dahil",
          "shippingEphInclNote": "Trendyol'un anlaşmalı tarifesi posta payını içeriyor, napelia.com'un DHL fiyatı (121,00 ₺) içermiyor. Kapatılırsa pay kargo netinin üzerine, KDV'den önce eklenir.",
          "shippingEphFromTariff": "Tarifenin kendi bayrağı karar veriyor — elle değiştirilemez",
          "serviceFee": "Hizmet bedeli",
          "vat": "Ürün KDV oranı",
          "packaging": "Ambalaj",
          "packagingUnit": "Bir kutu kaç adetlik",
          "packagingUnitHint": "Boş bırakılırsa ambalaj her paket boyunda sabit sayılır",
          "packagingUnitUsed": "Bu ilan {{n}} kutu yiyor (kutu bölünmez, yukarı yuvarlanır)",
          "packagingUnitEmpty": "ölçülmedi",
          "labour": "İşçilik",
          "other": "Diğer",
          "overhead": "Genel gider payı",
          "overheadHint": "Kira, ofis, mali müşavir ÷ normal kapasite · işçilik ayrı, çift sayma · stok değerlemesine girmez (TMS 2 p.16)",
          "inventoryDays": "Stokta bekleme",
          "inventoryDaysHint": "Vade maliyeti {{total}} gün üzerinden (stok + ödeme vadesi)",
          "campaign": "Kampanya indirimi",
          "campaignHint": "Beklenen indirim; liste fiyatı yukarı çıkar ki satış hedefi tutsun",
          "ads": "Reklam (ciro payı)",
          "returnPct": "İade oranı",
          "returnScrap": "İadede zayi",
          "payoutDays": "Ödeme vadesi",
          "capital": "Yıllık para maliyeti",
          "withholding": "Stopaj",
          "rounding": "Fiyat yuvarlama",
          "days": "gün",
          "netHint": "KDV hariç, ilan başına",
          "otherHint": "KDV hariç · kontör, abonelik payı",
          "returnScrapHint": "Geri gelenin satılamayan oranı; KDV'si de kaybolur (KDVK 30/c)",
          "capitalHint": "capital_cost_rates'ten okunur · itibari maliyet",
          "shippingVatIncl": "Kargo tutarı KDV dahil",
          "shippingVatInclNote": "Trendyol hakedişten KDV dahil düşer"
        },
        "rounding": {
          "none": "Yuvarlama yok",
          "integer": "Tam liraya",
          "x90": ",90 ile bitir",
          "x99": ",99 ile bitir"
        },
        "ladderCols": {
          "qty": "Adet",
          "price": "Liste fiyatı",
          "perUnit": "{{unit}} başına",
          "desi": "Desi",
          "shipShare": "Kargo payı",
          "packShare": "Ambalaj payı",
          "profit": "Katkı payı",
          "breakEven": "Başabaş"
        }
      },
      "amazon": {
        "title": "Amazon eşleşmeleri",
        "add": "Eşleşme ekle",
        "market": "Pazar",
        "sellerSku": "Seller SKU",
        "asin": "ASIN",
        "packQty": "Paket içi",
        "price": "Fiyat",
        "fbaStock": "FBA stok",
        "status": {
          "matched": "eşleşti",
          "sync_error": "senkron hatası",
          "manual": "manuel",
          "inactive": "pasif"
        },
        "unconfirmed": "Paket içi adet SKU listesi netleşince teyit edilecek — birim ekonomisi bu sayıdan türüyor.",
        "phaseBody": "Eşleşmeler, fiyat ve FBA stoğu Amazon bağlantısıyla gelecek."
      },
      "suppliers": {
        "title": "Tedarikçiler",
        "supplier": "Tedarikçi",
        "code": "Ürün kodu",
        "leadTime": "Tedarik süresi",
        "minOrder": "Min. sipariş",
        "lastPrice": "Son fiyat",
        "phaseBody": "Tedarikçi kartları ve son fiyatlar satın alma modülüyle gelecek."
      },
      "movements": {
        "title": "Hareketler",
        "date": "Tarih",
        "kind": "Tür",
        "route": "Kaynak → Hedef",
        "lot": "Lot",
        "qty": "Miktar",
        "empty": "Bu ürün için henüz hareket yok. İlk hareketi girdiğinde defter burada dolacak."
      },
      "documents": {
        "title": "Belgeler",
        "document": "Belge",
        "kind": "Tür",
        "uploader": "Yükleyen",
        "date": "Tarih",
        "kinds": {
          "specification": "Spesifikasyon",
          "quality": "Kalite",
          "design": "Tasarım",
          "label": "Etiket",
          "certificate": "Sertifika",
          "delivery_note": "İrsaliye",
          "photo": "Fotoğraf",
          "other": "Diğer"
        },
        "upload": "Belge yükle",
        "uploaded": "Belge yüklendi",
        "empty": "Henüz belge yok. Spesifikasyon, test raporu veya etiket şablonunu buraya ekle.",
        "kindTitle": "Belge türü"
      },
      "backToList": "Ürünlere dön",
      "notFound": "Ürün bulunamadı. Silinmiş ya da bu şirkete ait olmayabilir.",
      "moreActions": "Diğer işlemler",
      "activate": "Aktifleştir",
      "inactiveTitle": "Bu ürün pasif",
      "inactiveBody": "Yeni satın alma, üretim ve ürün ağaçlarında seçilemez. Geçmiş kayıtlar değişmez.",
      "draftTitle": "Taslak ürün",
      "draftBody": "Taslak ürün satış belgelerinde ve Amazon eşleşmesinde kullanılamaz."
    },
    "phaseSoon": "{{phase}} kapsamında açılacak",
    "maskedAria": "Maliyet gizli — rolün bu alanı göremez",
    "assign": {
      "subtitle": "{{count}} ürün seçildi",
      "attribute": "Nitelik",
      "value": "Değer",
      "clear": "Değeri boşalt",
      "preview": "Değişecek: {{count}} ürün",
      "previewChange": "{{count}} üründe değer değişecek",
      "previewFill": "{{count}} ürüne ilk kez yazılacak",
      "apply": "{{count}} ürüne uygula"
    }
  },
  "imports": {
    "breadcrumb": "İçe / dışa aktarma",
    "templateDownload": "Şablonu indir",
    "template": {
      "xlsx": "XLSX şablonu indir",
      "csv": "CSV şablonu indir"
    },
    "phaseLockedTitle": "Bu içe aktarım sonraki fazda",
    "phaseLockedBody": "Cari ve açılış bakiyesi içe aktarımı sonraki fazda gelecek.",
    "kinds": {
      "items": "Ürünler",
      "opening_stock": "Açılış stoğu",
      "contacts": "Cariler",
      "opening_balances": "Açılış bakiyeleri"
    },
    "title": {
      "items": "Ürün içe aktarımı",
      "opening_stock": "Açılış stoğu içe aktarımı",
      "contacts": "Cari içe aktarımı",
      "opening_balances": "Açılış bakiyeleri içe aktarımı"
    },
    "subtitle": {
      "items": "SKU, ad, tür, birim dönüşümleri ve standart maliyet · var olan SKU’lar atlanır",
      "opening_stock": "Depo, lokasyon ve lot bazında eldeki miktarlar · her satır “Açılış stoğu” hareketi olarak yazılır",
      "contacts": "Müşteri ve tedarikçi kartları",
      "opening_balances": "Cari, kasa ve banka açılış tutarları"
    },
    "steps": {
      "file": "Dosya yüklendi",
      "mapping": "Sütunlar eşlendi",
      "preview": "Satırlar doğrulandı",
      "result": "Kayıtlar yazıldı"
    },
    "stepNotes": {
      "done": "tamam",
      "active": "çalışıyor",
      "pending": "bekliyor",
      "waiting": "onay bekliyor"
    },
    "drop": {
      "title": "Dosyayı buraya bırak",
      "active": "Bırak — dosya okunacak",
      "hint": "{{kind}} şablonu · XLSX veya CSV · en fazla {{rows}} satır · {{size}} MB",
      "choose": "Dosya seç",
      "reading": "Okunuyor… {{done}} satır",
      "readingAria": "Dosya okunuyor"
    },
    "file": {
      "meta": "{{rows}} satır · {{size}} · {{when}}",
      "detected": "Algılanan tür",
      "template": "{{kind}} şablonu · v1",
      "mapping": "Şablon dışı dosya — sütunları eşle",
      "unreadable": "Okunamadı",
      "unreadableTitle": "Dosya okunamadı"
    },
    "preflight": {
      "title": "Başlamadan önce",
      "open": "Aç",
      "items": "Ürünler tanımlı",
      "itemsDetail": "{{count}} ürün",
      "itemsDetailLots": "{{count}} ürün · {{lots}} tanesi lot takipli",
      "warehouses": "Depolar ve lokasyonlar tanımlı",
      "warehousesDetail": "{{warehouses}} depo · {{locations}} lokasyon",
      "unitConversions": "Birim dönüşümleri",
      "unitConversionsDetail": "{{count}} üründe stok birimi dönüşümü yok",
      "unitsDetail": "{{count}} aktif birim",
      "unitsMissing": "Henüz ölçü birimi tanımlı değil.",
      "standardCosts": "Standart maliyetler",
      "standardCostsDetail": "{{count}} üründe standart maliyet yok — dosyada birim maliyet ver",
      "standardCostsOk": "Her üründe standart maliyet var",
      "opening": "Açılış stoğu açık",
      "openingLocked": "Açılış stoğu kilitlendi — düzeltme için sayım kullan.",
      "openingOpen": "Henüz kilitlenmedi",
      "note": {
        "items": "Var olan SKU’lar atlanır; yeni ürünler taslak olarak değil, dosyadaki duruma göre açılır.",
        "opening_stock": "Miktar, o ürün + lokasyon + lot için açılış tarihindeki toplam eldeki miktardır. Sistemde zaten stok varsa yalnızca fark yazılır; aynı dosyayı iki kez yüklemek stoğu ikiye katlamaz.",
        "contacts": "",
        "opening_balances": ""
      }
    },
    "history": {
      "title": "Yükleme geçmişi",
      "empty": "Henüz içe aktarım yok. Şablonu indir, doldur ve yükle.",
      "rows": "{{count}} satır",
      "rowsShort": "Satır",
      "file": "Dosya",
      "discarded": "İçe aktarımdan vazgeçildi"
    },
    "mapping": {
      "title": "Sütun eşlemesi",
      "count": "{{count}} sütun · ilk 5 satır örnek",
      "decimal": "Ondalık",
      "decimalComma": "Virgül (1.234,5)",
      "decimalDot": "Nokta (1,234.5)",
      "decimalShort": {
        "comma": "virgül",
        "dot": "nokta"
      },
      "dateFormat": "Tarih",
      "dateFormats": {
        "dmy": "GG.AA.YYYY",
        "ymd": "YYYY-AA-GG",
        "dmySlash": "GG/AA/YYYY"
      },
      "fileColumn": "Dosyadaki sütun",
      "field": "Alan",
      "samples": "Örnek değerler",
      "unnamed": "(adsız sütun)",
      "ignore": "Yok say",
      "fieldFor": "“{{column}}” sütununun alanı",
      "status": {
        "mapped": "eşleşti",
        "ignored": "yok sayılacak"
      },
      "missing": "Zorunlu sütun eksik: {{columns}}",
      "ok": "Zorunlu {{count}} sütun eşleşti · tarih biçimi {{date}} · ondalık ayırıcı {{decimal}}",
      "ignoredCount": "{{count}} sütun yok sayılacak",
      "previewTitle": "İlk satırların önizlemesi",
      "previewCount": "ilk {{shown}} / {{total}} satır"
    },
    "preview": {
      "openingDate": "Açılış tarihi",
      "openingDateHint": "Hareket tarihi olarak yazılır",
      "openingDateFuture": "Açılış tarihi ileri bir tarih olamaz.",
      "skipErrors": "Hatalı {{count}} satırı atla ve kalanları işle",
      "readAt": "Mevcut stoklar {{time}} itibarıyla okundu",
      "revalidate": "Yeniden doğrula",
      "staleTitle": "Satırlar yeniden doğrulandı",
      "staleBody": "Doğrulamadan sonra {{count}} satırın mevcut stoğu değişti. Kontrol edip yeniden işle.",
      "kpiOk": "Geçerli satır",
      "kpiOkUnit": "/ {{total}}",
      "kpiWarning": "Uyarılı",
      "kpiError": "Hatalı",
      "kpiLots": "Yeni lot",
      "kpiLotsNote": "Dosyada adı geçen, sistemde olmayan lotlar",
      "kpiValue": "Toplam değer",
      "rowsUnit": "satır",
      "lotsUnit": "lot",
      "unpriced": "{{count}} satırda dosyada maliyet yok",
      "filters": {
        "all": "Tümü",
        "ok": "Geçerli",
        "warning": "Uyarı",
        "error": "Hata",
        "unchanged": "Değişmeyen"
      },
      "searchPlaceholder": "SKU, lot, lokasyon ara…",
      "downloadErrors": "Hatalı satırları indir",
      "changeFile": "Dosyayı değiştir",
      "cols": {
        "row": "Satır",
        "item": "Ürün",
        "location": "Depo · lokasyon",
        "variance": "Mevcut → fark",
        "value": "Değer"
      },
      "noRows": "Bu filtrede satır yok.",
      "subtotal": "Toplam · {{count}} satır işlenecek",
      "lotNew": "yeni",
      "lotExisting": "mevcut",
      "lotAuto": "otomatik",
      "lotAutoNote": "Lot no boş — otomatik numara verilecek.",
      "noChange": "fark yok",
      "baseQtyHint": "Temel birime çevrilmiş miktar",
      "costFromFile": "{{cost}}/{{unit}} · dosya",
      "costFromStandard": "{{cost}}/{{unit}} · standart",
      "costMissing": "maliyet yok",
      "costStandard": "standart maliyet kullanılacak"
    },
    "rowStatus": {
      "preview": {
        "ok": "geçerli",
        "warning": "uyarı",
        "error": "hata",
        "unchanged": "değişmiyor",
        "skipped": "atlanacak"
      },
      "posted": {
        "ok": "işlendi",
        "warning": "işlendi",
        "error": "atlandı",
        "unchanged": "değişmedi",
        "skipped": "atlandı"
      }
    },
    "batchStatus": {
      "uploaded": "çalışıyor",
      "validating": "çalışıyor",
      "validated": "doğrulandı",
      "posting": "çalışıyor",
      "posted": "işlendi",
      "partial": "kısmen işlendi",
      "failed": "hata",
      "reverted": "geri alındı",
      "discarded": "vazgeçildi"
    },
    "confirm": {
      "title": "Açılış stoğunu işle",
      "body": "Onayladığında {{count}} açılış hareketi oluşur ve stok kalıcı olarak değişir. İlk {{seconds}} saniye içinde geri alabilirsin; sonrasında ters kayıt gerekir.",
      "cta": "{{count}} hareketi oluştur",
      "groupMeta": "{{rows}} satır · {{lots}} yeni lot",
      "total": "Toplam değer etkisi",
      "reason": "Sebep olarak “Açılış stoğu” işaretlenecek ve {{date}} tarihli sayım oturumuna bağlanacak",
      "decreases": "{{count}} satır mevcut stoktan düşük — açılış miktarı düşürülemez, bu satırlar işlenmez; düzeltme için sayım kullan.",
      "withoutCost": "{{count}} satırda dosyada maliyet yok",
      "skipped": "{{count}} hatalı satır atlanacak",
      "unpriced": "{{count}} satır toplam değere girmedi — maliyeti ürünün standart maliyetinden alınacak."
    },
    "result": {
      "title": "Açılış stoğu işlendi",
      "bodyStock": "{{movements}} hareket yazıldı ({{first}} – {{last}}) · {{counts}} sayım oturumu · {{lots}} yeni lot · toplam {{value}}",
      "bodyItems": "{{created}} ürün eklendi · {{updated}} ürün güncellendi · {{skipped}} satır atlandı",
      "revertedTitle": "İçe aktarım geri alındı",
      "revertedBody": "{{count}} ters hareket yazıldı. Stok açılıştan önceki haline döndü.",
      "goStock": "Eldeki stoğa git",
      "goItems": "Ürünlere git",
      "newImport": "Yeni içe aktarım",
      "rowsTitle": "İşlenen satırlar",
      "rowsUnread": "İşlenen satırlar yeniden okunamadı — aşağıdaki liste doğrulama anındaki hâli gösteriyor.",
      "cols": {
        "movement": "Hareket no"
      },
      "goLedger": "Hareket defterini aç",
      "printLabels": "Yeni lotlar için etiket yazdır ({{count}})",
      "toast": "Açılış stoğu işlendi — {{count}} hareket"
    },
    "revert": {
      "cta": "Ters kayıtla geri al",
      "title": "Açılış stoğu geri alınsın mı?",
      "bodyStock": "{{count}} ters hareket yazılacak, değer etkisi {{value}} kadar azalacak. Açılıştan sonra bu lotlardan çıkış yapıldıysa geri alma engellenir.",
      "bodyItems": "Bu içe aktarımın oluşturduğu ve hiç hareket görmemiş ürünler pasife alınır. Güncellenen ürünler geri alınmaz; önceki değerler denetim günlüğünde.",
      "confirm": "Geri al",
      "blockedTitle": "Geri alınamadı"
    },
    "cta": {
      "mapColumns": "Sütunları eşle",
      "validate": "Doğrula",
      "validating": "Doğrulanıyor… {{done}} / {{total}}",
      "validatingShort": "Doğrulanıyor…",
      "post": "Stoğa işle",
      "done": "Bitti",
      "hasErrors": "{{count}} hatalı satır var — düzelt veya atla.",
      "nothingToPost": "İşlenecek fark yok — tüm satırlar mevcut stokla aynı."
    },
    "footer": {
      "templateComplete": "Şablon eksiksiz — sütun eşleme adımı atlanacak",
      "needsMapping": "Şablon dışı dosya — sütunları eşle",
      "mapping": "Eşlemeyi kontrol et, sonra doğrula",
      "preview": "{{count}} satır işlenecek · {{skipped}} satır atlanacak · {{lots}} yeni lot",
      "result": "{{count}} hareket yazıldı · {{skipped}} satır atlandı · {{unchanged}} satır değişmedi"
    },
    "cancel": {
      "title": "İçe aktarımdan vazgeçilsin mi?",
      "body": "Doğrulanan satırlar silinir, stok değişmez. Dosya geçmişte “vazgeçildi” olarak kalır.",
      "keep": "Devam et"
    },
    "states": {
      "offlineTitle": "Bağlantı yok",
      "offlineBody": "Dosya okunabilir ama doğrulama ve işleme için bağlantı gerekli.",
      "failedTitle": "İşlem tamamlanamadı",
      "blockedTitle": "Ön koşul eksik",
      "blockedBody": "Ön koşullar tamamlanmadan dosya doğrulanamaz."
    },
    "errors": {
      "type": "Bu dosya türü desteklenmiyor. XLSX, CSV veya TSV yükle.",
      "tooLarge": "Dosya {{size}} MB sınırını aşıyor.",
      "noRows": "Dosyada veri satırı yok.",
      "tooManyRows": "Dosyada {{count}} satır var; en fazla {{max}} satır yüklenebilir. Dosyayı depo bazında böl.",
      "unreadable": "Dosya şifreli veya bozuk görünüyor. Excel’de açıp yeniden kaydet.",
      "alreadyPosted": "Bu dosya {{when}} tarihinde zaten işlendi. Tekrar işlemek yalnızca farkları yazar.",
      "uploadFailed": "Dosyanın kopyası arşive yüklenemedi — içe aktarım yine de sürdürülebilir.",
      "sheetFallback": "“{{sheet}}” sayfası bulunamadı — ilk sayfa okundu.",
      "templateFailed": "Şablon dosyası oluşturulamadı. Sayfayı yenileyip tekrar dene."
    },
    "section": {
      "importTitle": "İçe aktar",
      "historyTitle": "İçe aktarım geçmişi",
      "cards": {
        "items": "SKU, ad, tür, birim dönüşümleri, yeniden sipariş noktası ve standart maliyet. Var olan SKU’lar atlanır.",
        "opening_stock": "Depo, lokasyon ve lot bazında açılış miktarları. Her satır “Açılış stoğu” sebebiyle stok hareketi olarak yazılır; stok hiçbir zaman doğrudan değişmez.",
        "contacts": "Müşteri ve tedarikçi kartları: unvan, VKN/TCKN, ülke, para birimi, vade ve iletişim bilgileri.",
        "opening_balances": "Carilerin açık alacak/borç bakiyeleri ile kasa ve banka hesaplarının açılış tutarları."
      },
      "lastImport": "Son içe aktarım: {{when}} · {{rows}} satır",
      "never": "Henüz içe aktarım yok",
      "partnersOnly": "İçe aktarma yalnızca ortaklara açık.",
      "openingLocked": "Açılış stoğu kilitli — düzeltmeler sayımla yapılır.",
      "template": "Şablon",
      "start": "İçe aktar",
      "resume": "Bekleyen içe aktarımı aç",
      "exportsLater": "Dışa aktarımlar bu bölüme sonraki turda eklenecek; tablolardaki “Dışa aktar” düğmesi şimdilik CSV veriyor."
    },
    "codes": {
      "sku_required": "SKU zorunlu",
      "sku_format": "SKU biçimi",
      "sku_duplicate": "SKU tekrar ediyor",
      "name_required": "Ad zorunlu",
      "type_required": "Tür zorunlu",
      "type_unknown": "Tür tanınmadı",
      "base_unit_default": "Temel birim varsayıldı",
      "barcode_check_digit": "Barkod kontrol hanesi",
      "already_exists": "Zaten var",
      "lot_tracked_locked": "Lot takibi kapatılamaz",
      "item_unknown": "Ürün bulunamadı",
      "item_not_stocked": "Stok tutulmaz",
      "item_draft": "Taslak ürün",
      "name_mismatch": "Ad farklı",
      "warehouse_unknown": "Depo bulunamadı",
      "fba_forbidden": "FBA deposu",
      "location_warehouse": "Lokasyon başka depoda",
      "location_unknown": "Lokasyon bulunamadı",
      "row_duplicate": "Satır tekrar ediyor",
      "qty_required": "Miktar zorunlu",
      "qty_positive": "Miktar eksi",
      "qty_not_integral": "Miktar bölünemez",
      "unit_unknown": "Birim tanımlı değil",
      "unit_default": "Birim varsayıldı",
      "lot_not_allowed": "Lot girilemez",
      "lot_item_mismatch": "Lot başka üründe",
      "lot_required": "Lot no gerekli",
      "currency_unknown": "Para birimi tanınmadı",
      "fx_missing": "Kur yok",
      "cost_missing": "Maliyet yok",
      "opening_decrease": "Açılış düşürülemez",
      "opening_locked": "Açılış kilitli",
      "unchanged": "Değişmiyor"
    }
  },
  "documents": {
    "title": "Evraklar",
    "empty": "Henüz evrak yok",
    "emptyBody": "Sicil gazetesi, kira sözleşmesi, ruhsatlar, poliçeler — şirketin evrakları buraya yüklenir.",
    "noFolder": "Klasörsüz",
    "maxSize": "en çok {{mb}} MB",
    "upload": "Belge yükle",
    "uploaded": "Belge yüklendi",
    "open": "Aç",
    "share": "Paylaş",
    "download": "İndir",
    "linkCopied": "Bağlantı kopyalandı",
    "archive": "Arşivle",
    "archiveTitle": "Belgeyi arşivle",
    "archiveBody": "Belge listeden kalkar ama dosya hemen yok olmaz: kaydı ve denetim izi kalır.",
    "archived": "Belge arşivlendi",
    "fields": {
      "name": "Belge adı",
      "fileName": "Dosya",
      "titleHint": "Boş bırakırsan dosya adı kullanılır.",
      "folder": "Klasör",
      "fileType": "Tür",
      "size": "Boyut",
      "uploader": "Yükleyen",
      "uploadedAt": "Yüklendi",
      "validUntil": "Geçerlilik",
      "validUntilHint": "Sözleşme, ruhsat, poliçe gibi tarihi takip edilen evraklar için.",
      "note": "Not"
    },
    "validity": {
      "none": "Süresiz",
      "valid": "{{date}} tarihine kadar",
      "soon": "{{date}} — {{days}} gün kaldı",
      "expired": "{{date}} — {{days}} gün önce doldu",
      "badgeExpired": "süresi doldu",
      "badgeSoon": "{{days}} gün kaldı",
      "expiredNote": "Bu belgenin geçerliliği {{date}} tarihinde doldu — yenisini yükleyebilirsin.",
      "soonNote": "Bu belgenin geçerliliği {{date}} tarihinde doluyor."
    },
    "cabinet": {
      "subtitle": "{{count}} belge · şirketin evrak dolabı",
      "searchPlaceholder": "Belge adı, not ara…",
      "csvName": "evraklar",
      "dropHere": "Dosyaları buraya bırak",
      "emptyFolder": "Bu klasörde belge yok. “Belge yükle” ile ekleyebilirsin.",
      "emptySearch": "Aramaya uyan belge yok."
    },
    "folders": {
      "title": "Klasörler",
      "add": "Klasör ekle",
      "addTitle": "Yeni klasör",
      "renameTitle": "Klasörü yeniden adlandır",
      "name": "Klasör adı",
      "namePlaceholder": "Örn. Kira sözleşmeleri",
      "rename": "yeniden adlandır",
      "remove": "klasörü sil",
      "removeTitle": "Klasörü sil",
      "removeConfirm": "“{{name}}” klasörü listeden kalkacak. Klasör boş — arşivlenir, kaydı silinmez.",
      "notEmptyHint": "İçinde {{count}} belge var — silmek için önce belgeleri başka klasöre taşı ya da arşivle.",
      "saved": "Klasör kaydedildi",
      "removed": "Klasör kaldırıldı"
    },
    "uploadForm": {
      "title": "Belge yükle",
      "subtitle": "Dosya başına en çok {{size}} MB · PDF, görsel, Office, metin",
      "pick": "Dosya seç",
      "pickMore": "Dosya ekle",
      "pickHint": "Dosyaları bu alana sürükleyebilir ya da “Dosya seç” ile seçebilirsin.",
      "start": "Yükle",
      "startCount": "{{count}} dosyayı yükle",
      "stop": "Yüklemeyi durdur",
      "stopHint": "Sıradaki dosyalar yüklenmez; süren dosya tamamlanır.",
      "progress": "{{done}} / {{total}} yüklendi",
      "leaveWarning": "Yükleme sürüyor — sayfadan ayrılırsan kalan dosyalar yüklenmez.",
      "remove": "listeden çıkar",
      "status": {
        "waiting": "bekliyor",
        "uploading": "yükleniyor…",
        "done": "yüklendi",
        "error": "yüklenemedi",
        "skipped": "durduruldu"
      },
      "tooBig": "Dosya {{size}} MB sınırını aşıyor.",
      "unsupported": "Bu dosya türü yüklenemiyor.",
      "done": "{{count}} belge yüklendi",
      "partial": "{{done}} belge yüklendi, {{failed}} dosya yüklenemedi.",
      "stopped": "{{done}} belge yüklendi, {{count}} dosya durduruldu — “Yükle” ile kaldığı yerden devam edebilirsin."
    },
    "viewer": {
      "newTab": "Yeni sekmede aç",
      "pdfTitle": "{{name}} — belge önizlemesi",
      "pdfHint": "Önizleme boş görünüyorsa tarayıcın PDF’leri içinde açmıyor: “İndir” ya da “Yeni sekmede aç” ile açabilirsin.",
      "zoom": "Görüntü boyutu",
      "fit": "Sığdır",
      "actual": "Orijinal boyut",
      "noPreview": "Bu dosya türü uygulama içinde gösterilemiyor. İndirip cihazda açabilir ya da paylaşabilirsin.",
      "imageFailed": "Bu görsel tarayıcıda açılamadı (HEIC, TIFF gibi türler). İndirdiğinde cihazında açılır.",
      "textTooBig": "Dosya önizleme için büyük ({{limit}} KB üstü). İndirip açabilirsin.",
      "saved": "Belge güncellendi"
    },
    "sharing": {
      "warningTitle": "Bağlantıya sahip herkes açabilir",
      "warning": "Bu bağlantıyı açan herkes, süresi dolana kadar belgeyi görebilir — uygulamaya girmesi ya da şirkette üye olması gerekmez. Yalnızca göndermek istediğin kişiye ilet.",
      "duration": "Bağlantı süresi",
      "hour": "1 saat",
      "day": "1 gün",
      "week": "7 gün",
      "create": "Bağlantı oluştur ve kopyala",
      "again": "Yeni bağlantı oluştur",
      "link": "Paylaşım bağlantısı",
      "expires": "Bağlantı {{time}} tarihine kadar geçerli. Kopyalanmadıysa alanı seçip kopyalayabilirsin."
    }
  },
  "market": {
    "title": "Piyasa",
    "settingLabel": "Piyasa şeridi",
    "settingHint": "Dolar, euro, sterlin, gram altın ve BIST 100 ekranın üstünde akar. Veriler günlük kapanıştır, işlem için kullanılmaz.",
    "asOf": "{{date}} kapanışı",
    "source": {
      "TCMB": "TCMB",
      "EVDS": "TCMB EVDS",
      "MANUAL": "Elle girildi"
    }
  }
}
